import React, { useState, useEffect, useRef, useContext } from 'react';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import { useSelector } from 'react-redux';
import usePermission from '../../custom/usePermission';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Tooltip } from 'primereact/tooltip';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { AuthContext } from '../../Header/auth - context';

const MESECI = [
    { value: 1,  label: 'Januar' },  { value: 2,  label: 'Februar' },
    { value: 3,  label: 'Mart' },    { value: 4,  label: 'April' },
    { value: 5,  label: 'Maj' },     { value: 6,  label: 'Jun' },
    { value: 7,  label: 'Jul' },     { value: 8,  label: 'Avgust' },
    { value: 9,  label: 'Septembar' },{ value: 10, label: 'Oktobar' },
    { value: 11, label: 'Novembar' },{ value: 12, label: 'Decembar' },
];

const toUtcIso = (d) => {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
};

const fmt = (v) => {
    if (v == null) return '0.00';
    const rounded = Math.round(Number(v) * 100) / 100;
    return (rounded === 0 ? 0 : rounded).toFixed(2);
};

const EUR_ID = 186;
const RSD_ID = 220;
const EUR_RSD_OPTIONS = [{ value: EUR_ID, label: 'EUR' }, { value: RSD_ID, label: 'RSD' }];

const emptyHeader = {
    kurs: 0, radnih_dana: 0,
    saldo_prethodni: 0, dug_prethodni: 0, minimalac: 0, minimalac_valuta: EUR_ID, dnevnica_ukupno: 0,
    dnevnica_godisnji: 0, dnevnica_bolovanje: 0, dnevnica_rus_fix: 0, dnevnica_rus_dani: 0,
    bonus_g: 0, bonus_g_valuta: EUR_ID,
    telefon: 0, telefon_valuta: EUR_ID,
    gorivo_eur: 0, gorivo_valuta: EUR_ID,
    isplata_putnih_troskova: 0, isplata_putnih_valuta: EUR_ID,
    valuta_zaglavlja: null, napomena: '',
};

const emptyNalog = {
    km: 0, dodatni_km: 0, iznos_eur: 0, akontacija_eur: 0, akontacija_rsd: 0,
    trosak_eur: 0, ostao_duzan_eur: 0, ostao_duzan_rsd: 0,
    bonus_opis: '', bonus_iznos_eur: 0, napomena: '',
};

const emptyIsplata = { datum_isplate: null, opis_isplate: '', tip: null, iznos_eur_isp: 0, iznos_rsd_isp: 0 };

const ObracunPlate = () => {
  const { t } = useTranslation();
    const toast     = useRef(null);
    const auth      = useContext(AuthContext);
    const company   = useSelector(s => s.company);
    const user_role = useSelector(s => s.user_role);
    const eskaliran = useSelector(s => s.eskaliran);
    const { can } = usePermission();
    const canUnlock = can('FINANSIJE', 'edit');

    const now = new Date();
    const defaultMesec  = now.getMonth() === 0 ? 12 : now.getMonth();
    const defaultGodina = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();

    const [changeView, setChangeView] = useState(1);
    const [unosTab,    setUnosTab]    = useState(1); // 1=STAVKE 2=BONUSI 3=DANI
    const [zaposleniDB,        setZaposleniDB]        = useState([]);
    const [bonusiSifarnikDB,   setBonusiSifarnikDB]   = useState([]);
    const [tipIsplateDB,       setTipIsplateDB]       = useState([]);
    const [zaglavljeStavke,    setZaglavljeStavke]    = useState([]); // config from INIT
    const [zaglavljeVrednosti, setZaglavljeVrednosti] = useState({}); // {[id_stavka]: {iznos, valuta_id}}
    const [zaglavljeValuteDB,  setZaglavljeValuteDB]  = useState([]);
    const [zaglavljeTipDB,     setZaglavljeTipDB]     = useState([]);

    /* ---- PREGLED ---- */
    const [pregledData,       setPregledData]       = useState([]);
    const [filterZap,         setFilterZap]         = useState(null);
    const [filterMesec,       setFilterMesec]       = useState(null);
    const [filterGodina,      setFilterGodina]      = useState(now.getFullYear());
    const [pregledGlobalFilter, setPregledGlobalFilter] = useState(null);
    const [selectedPregledId, setSelectedPregledId] = useState(null);

    /* ---- UNOS generator ---- */
    const [genZap,     setGenZap]     = useState(null);
    const [genMesec,   setGenMesec]   = useState(defaultMesec);
    const [genGodina,  setGenGodina]  = useState(defaultGodina);
    const [genDatOd,   setGenDatOd]   = useState(null);
    const [genDatDo,   setGenDatDo]   = useState(null);
    const [genDnevniceOd, setGenDnevniceOd] = useState(null);
    const [genDnevniceDo, setGenDnevniceDo] = useState(null);
    const [generating, setGenerating] = useState(false);

    /* ---- obračun data ---- */
    const [obracunId,     setObracunId]     = useState(null);
    const [obracunStatusNaziv, setObracunStatusNaziv] = useState(null);
    const [zapNaziv,      setZapNaziv]      = useState('');
    const [obradioNaziv,  setObradioNaziv]  = useState('');
    const [formHeader,    setFormHeader]    = useState({ ...emptyHeader });
    const [nalozi,        setNalozi]        = useState([]);
    const [dani,          setDani]          = useState([]);
    const [isplate,       setIsplate]       = useState([]);
    const [bonusi,        setBonusi]        = useState([]);
    const [akontacijeStandalone, setAkontacijeStandalone] = useState([]);

    /* ---- bonus forma ---- */
    const [formBonus,       setFormBonus]       = useState({ id_sifarnik: null, id_obracun_nalog: null, opis_bonus: '', iznos_eur_bon: 0 });
    const [selectedBonusId, setSelectedBonusId] = useState(null);
    const [filteredBonusiSifarnikPlate, setFilteredBonusiSifarnikPlate] = useState([]);
    const [bonusSubmitted, setBonusSubmitted] = useState(false);
    const [isplataSubmitted, setIsplataSubmitted] = useState(false);

    /* ---- nalog edit ---- */
    const [selectedNalogId, setSelectedNalogId] = useState(null);
    const [formNalog,       setFormNalog]       = useState({ ...emptyNalog });

    /* ---- isplata form ---- */
    const [formIsplata,      setFormIsplata]      = useState({ ...emptyIsplata });
    const [selectedIsplataId, setSelectedIsplataId] = useState(null);

    /* ---- nalog GlobalFilter ---- */
    const [naloziGlobalFilter, setNaloziGlobalFilter] = useState(null);

    /* ---- dodavanje ture manuelno ---- */
    const [availableTrips, setAvailableTrips]   = useState([]);
    const [selectedAddTrip, setSelectedAddTrip] = useState(null);
    const [loadingAvailable, setLoadingAvailable] = useState(false);
    const [addingTrip, setAddingTrip]           = useState(false);
    const [showAddTrip, setShowAddTrip]         = useState(false);

    const isLocked = obracunStatusNaziv === 'ZATVOREN';

    /* auto-compute period (Ture od/do - obračunski ciklus 6.-5.) */
    useEffect(() => {
        setGenDatOd(new Date(genGodina, genMesec - 1, 6));
        setGenDatDo(new Date(genGodina, genMesec, 5));
    }, [genMesec, genGodina]);

    /* auto-compute period (Dnevnice od/do - kalendarski mesec, 1. do poslednjeg dana) */
    useEffect(() => {
        setGenDnevniceOd(new Date(genGodina, genMesec - 1, 1));
        setGenDnevniceDo(new Date(genGodina, genMesec, 0));
    }, [genMesec, genGodina]);

    const api = async (payload) => {
        const res = await axios.post(
            process.env.REACT_APP_BACKEND_URL + '/finance/ManageObracunPlate',
            payload,
            { headers: { Authorization: 'Bearer ' + auth.token } }
        );
        return res.data;
    };

    const showToast = (severity, msg, life = 3500) =>
        toast.current?.show({ severity, summary: msg, life });

    const invalidBonus = (val) => bonusSubmitted && (val === null || val === '' || val === undefined);
    const invalidIsplata = (val) => isplataSubmitted && (val === null || val === '' || val === undefined);

    const fetchSifarnikForNalog = async (id_obracun_nalog) => {
        if (!id_obracun_nalog || !genZap) { setFilteredBonusiSifarnikPlate([]); return; }
        const nalog = nalozi.find(n => n.id === id_obracun_nalog);
        if (!nalog?.id_putni_nalog) { setFilteredBonusiSifarnikPlate([]); return; }
        try {
            const res = await axios.post(
                process.env.REACT_APP_BACKEND_URL + '/trip/ManageTuraBonusiDani',
                { step: 'GET_SIFARNIK_FOR_VOZAC', id_putni_nalog: nalog.id_putni_nalog, id_zaposleni: genZap },
                { headers: { Authorization: 'Bearer ' + auth.token } }
            );
            setFilteredBonusiSifarnikPlate(res.data?.BonusiSifarnikDB || []);
        } catch { setFilteredBonusiSifarnikPlate([]); }
    };

    /* INIT */
    useEffect(() => {
        const load = async () => {
            try {
                const data = await api({ step: 'INIT' });
                setZaposleniDB(data?.ZaposleniDB || []);
                setBonusiSifarnikDB(data?.BonusiSifarnikDB || []);
                setTipIsplateDB(data?.TipIsplateDB || []);
                setZaglavljeStavke(data?.ZaglavljeStavkeDB || []);
                setZaglavljeValuteDB(data?.ValuteDB || []);
                setZaglavljeTipDB(data?.TipTransakcijeDB || []);
            } catch { showToast('error', 'Greška pri učitavanju zaposlenih'); }
        };
        load();
    }, []); // eslint-disable-line

    /* default Tip isplate = 'Isplata (plata)' kad se učita šifarnik */
    useEffect(() => {
        if (!formIsplata.tip && tipIsplateDB.length > 0) {
            const def = tipIsplateDB.find(t => t.label === 'Isplata (plata)');
            if (def) setFormIsplata(p => ({ ...p, tip: def.value }));
        }
    }, [tipIsplateDB]); // eslint-disable-line

    /* PREGLED load */
    const loadPregled = async () => {
        try {
            let mesecStr = null;
            if (filterMesec && filterGodina)
                mesecStr = `${filterGodina}-${String(filterMesec).padStart(2,'0')}-01`;
            const data = await api({ step: 'GET_PREGLED', id_zaposleni: filterZap || null, mesec: mesecStr });
            setPregledData(Array.isArray(data) ? data : []);
            setSelectedPregledId(null);
        } catch { showToast('error', 'Greška pri učitavanju pregleda'); }
    };

    useEffect(() => { if (changeView === 2) loadPregled(); }, [changeView]); // eslint-disable-line

    /* GET_OBRACUN */
    const loadObracun = async (id) => {
        try {
            const data = await api({ step: 'GET_OBRACUN', id });
            const h = data?.HeaderDB?.[0];
            if (!h) {
                if (data?.message) showToast('warn', data.message);
                return;
            }
            setObracunId(h.id);
            setObracunStatusNaziv(h.StatusNaziv);
            setZapNaziv(h.ZaposleniNaziv || '');
            setObradioNaziv(h.ObradioNaziv || '');
            setGenZap(h.id_zaposleni || null);
            setFormHeader({
                kurs: h.kurs || 0, radnih_dana: h.radnih_dana || 0,
                saldo_prethodni: h.saldo_prethodni || 0, dug_prethodni: h.dug_prethodni || 0, minimalac: h.minimalac || 0,
                minimalac_valuta: h.minimalac_valuta || EUR_ID,
                dnevnica_ukupno: h.dnevnica_ukupno || 0,
                dnevnica_godisnji: h.dnevnica_godisnji || 0,
                dnevnica_bolovanje: h.dnevnica_bolovanje || 0,
                dnevnica_rus_fix: h.dnevnica_rus_fix || 0,
                dnevnica_rus_dani: h.dnevnica_rus_dani || 0,
                bonus_g: h.bonus_g || 0, bonus_g_valuta: h.bonus_g_valuta || EUR_ID,
                telefon: h.telefon || 0, telefon_valuta: h.telefon_valuta || EUR_ID,
                gorivo_eur: h.gorivo_eur || 0, gorivo_valuta: h.gorivo_valuta || EUR_ID,
                isplata_putnih_troskova: h.isplata_putnih_troskova || 0,
                isplata_putnih_valuta: h.isplata_putnih_valuta || EUR_ID,
                valuta_zaglavlja: h.valuta_zaglavlja || EUR_ID,
                napomena: h.napomena || '',
            });
            if (h.mesec) {
                const md = new Date(h.mesec);
                setGenMesec(md.getMonth() + 1);
                setGenGodina(md.getFullYear());
            }
            setNalozi(data?.NaloziDB || []);
            setDani(data?.DaniDB || []);
            setIsplate(data?.IsplateDB || []);
            setBonusi(data?.BonusiDB || []);
            setAkontacijeStandalone(data?.AkontacijeStandaloneDB || []);
            if (data?.BonusiSifarnikDB) setBonusiSifarnikDB(data.BonusiSifarnikDB);

            /* zaglavlje vrednosti — saved > auto-computed */
            {
                const savedMap = {};
                (data?.ZaglavljeVrednostiDB || []).forEach(v => { savedMap[v.id_stavka] = { iznos: v.iznos, valuta_id: v.valuta_id }; });
                const autoMap = {};
                (data?.ZaglavljeAutoVrednostiDB || []).forEach(v => { if (v.iznos !== null) autoMap[v.id_stavka] = { iznos: v.iznos, valuta_id: v.valuta_id }; });
                const merged = {};
                (zaglavljeStavke.length ? zaglavljeStavke : (data?.ZaglavljeAutoVrednostiDB || []).map(v => ({ value: v.id_stavka }))).forEach(s => {
                    merged[s.value] = savedMap[s.value] || autoMap[s.value] || { iznos: 0, valuta_id: s.valuta_id || EUR_ID };
                });
                setZaglavljeVrednosti(merged);
            }

            setSelectedNalogId(null);
            setFormNalog({ ...emptyNalog });
            setFormIsplata({ ...emptyIsplata });
            setSelectedIsplataId(null);
            setFormBonus({ id_sifarnik: null, id_obracun_nalog: null, opis_bonus: '', iznos_eur_bon: 0 });
            setSelectedBonusId(null);
            setFilteredBonusiSifarnikPlate([]);
        } catch { showToast('error', 'Greška pri učitavanju obračuna'); }
    };

    /* reset učitanog obračuna — UNOS tab kreće prazan, popunjava se samo kroz PREGLED → Izaberi */
    const resetUnos = () => {
        setObracunId(null);
        setObracunStatusNaziv(null);
        setZapNaziv('');
        setObradioNaziv('');
        setFormHeader({ ...emptyHeader });
        setNalozi([]);
        setDani([]);
        setIsplate([]);
        setBonusi([]);
        setSelectedNalogId(null);
        setSelectedPregledId(null);
        setUnosTab(1);
        setFormNalog({ ...emptyNalog });
        setFormIsplata({ ...emptyIsplata });
        setSelectedIsplataId(null);
        setFormBonus({ id_sifarnik: null, id_obracun_nalog: null, opis_bonus: '', iznos_eur_bon: 0 });
        setSelectedBonusId(null);
        setFilteredBonusiSifarnikPlate([]);
        setGenZap(null);
        setGenMesec(defaultMesec);
        setGenGodina(defaultGodina);
    };

    /* GENERATE */
    const handleGenerate = async () => {
        if (!genZap) return showToast('warn', 'Izaberite zaposlenog');
        setGenerating(true);
        try {
            const mesecStr = `${genGodina}-${String(genMesec).padStart(2,'0')}-01`;
            const result = await api({
                step: 'GENERATE', id_zaposleni: genZap, mesec: mesecStr,
                dat_od: toUtcIso(genDatOd), dat_do: toUtcIso(genDatDo),
                dnevnice_od: toUtcIso(genDnevniceOd), dnevnice_do: toUtcIso(genDnevniceDo),
            });
            const row = Array.isArray(result) ? result[0] : result;
            if (row?.ID) {
                await loadObracun(row.ID);
                if (row.warning) showToast('warn', row.warning, 10000);
                if (row.gorivo_warn) showToast('warn', row.gorivo_warn, 8000);
                if (!row.warning && !row.gorivo_warn) showToast('success', 'Obračun generisan!');
            } else {
                showToast('warn', row?.message || 'Greška');
            }
        } catch (e) {
            showToast('error', e?.response?.data?.message || 'Greška pri generisanju');
        } finally { setGenerating(false); }
    };

    /* selekcija reda u PREGLED — otvara obračun za izmenu u UNOS tabu */
    const handlePregledSelect = (row) => {
        const id = row?.id;
        setSelectedPregledId(prev => {
            const next = String(prev) === String(id) ? null : id;
            if (next !== null) {
                loadObracun(id);
                setChangeView(1);
                setUnosTab(1);
            }
            return next;
        });
    };

    /* SAVE HEADER */
    const handleSaveHeader = async () => {
        try {
            const zaglavljeArr = Object.entries(zaglavljeVrednosti).map(([id_stavka, v]) => ({
                id_stavka: parseInt(id_stavka), iznos: v?.iznos || 0, valuta_id: v?.valuta_id || EUR_ID,
            }));
            const result = await api({ step: 'SAVE_HEADER', id: obracunId, ...formHeader, zaglavljeVrednosti: zaglavljeArr });
            const row = Array.isArray(result) ? result[0] : result;
            showToast(row?.ID ? 'success' : 'warn', row?.message || 'OK');
        } catch (e) { showToast('error', e?.response?.data?.message || 'Greška'); }
    };

    /* REMOVE NALOG */
    const handleRemoveNalog = (id) => {
        confirmDialog({
            message: 'Ukloni ovu turu iz obračuna?', acceptLabel: 'Da', rejectLabel: 'Ne',
            icon: 'pi pi-info-circle', acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    const result = await api({ step: 'REMOVE_NALOG', id: obracunId, id_nalog_row: id });
                    const row = Array.isArray(result) ? result[0] : result;
                    if (row?.ID) {
                        setNalozi(prev => prev.filter(n => n.id !== id));
                        if (selectedNalogId === id) { setSelectedNalogId(null); setFormNalog({ ...emptyNalog }); }
                        showToast('success', 'Tura uklonjena!');
                    } else { showToast('warn', row?.message || 'Greška'); }
                } catch { showToast('error', 'Greška pri uklanjanju ture'); }
            },
        });
    };

    /* GET AVAILABLE NALOZI */
    const loadAvailableTrips = async () => {
        if (!genZap) return;
        setLoadingAvailable(true);
        try {
            const data = await api({ step: 'GET_AVAILABLE_NALOZI', id_zaposleni: genZap });
            setAvailableTrips(Array.isArray(data) ? data : []);
        } catch { showToast('error', 'Greška pri učitavanju dostupnih tura'); }
        finally { setLoadingAvailable(false); }
    };

    /* ADD NALOG MANUAL */
    const handleAddNalogManual = async () => {
        if (!selectedAddTrip) return showToast('warn', 'Izaberite turu');
        setAddingTrip(true);
        try {
            const result = await api({ step: 'ADD_NALOG_MANUAL', id: obracunId, id_putni_nalog: selectedAddTrip });
            const row = Array.isArray(result) ? result[0] : result;
            if (row?.ID) {
                await loadObracun(obracunId);
                setSelectedAddTrip(null);
                setShowAddTrip(false);
                showToast('success', 'Tura dodata u obračun!');
            } else { showToast('warn', row?.message || 'Greška'); }
        } catch (e) { showToast('error', e?.response?.data?.message || 'Greška'); }
        finally { setAddingTrip(false); }
    };

    /* NALOG select toggle */
    const handleNalogSelect = (row) => {
        const id = row?.id;
        setSelectedNalogId(prev => {
            const next = String(prev) === String(id) ? null : id;
            if (next !== null) {
                const dugEur = Number(row.ostatak_eur || 0) - Number(row.trosak_gotovina_eur || 0);
                const dugRsd = Number(row.akontacija_rsd || 0) - Number(row.razduzenje_rsd || 0);
                setFormNalog({
                    km: row.km || 0, dodatni_km: row.dodatni_km || 0, iznos_eur: row.iznos_eur || 0,
                    akontacija_eur: row.akontacija_eur || 0, akontacija_rsd: row.akontacija_rsd || 0,
                    trosak_eur: row.trosak_eur || 0, ostao_duzan_eur: dugEur,
                    ostao_duzan_rsd: dugRsd,
                    bonus_opis: row.bonus_opis || '', bonus_iznos_eur: row.bonus_iznos_eur || 0,
                    napomena: row.napomena || '',
                });
            } else {
                setFormNalog({ ...emptyNalog });
            }
            return next;
        });
    };

    /* SAVE NALOG */
    const handleSaveNalog = async () => {
        if (!selectedNalogId) return;
        try {
            const result = await api({ step: 'SAVE_NALOG', id_nalog_row: selectedNalogId, ...formNalog });
            const row = Array.isArray(result) ? result[0] : result;
            if (row?.ID) {
                setNalozi(prev => prev.map(n => n.id === selectedNalogId
                    ? { ...n, ...formNalog, km: row.km, dodatni_km: row.dodatni_km, iznos_eur: row.iznos_eur, ima_rusiju: row.ima_rusiju }
                    : n));
                setSelectedNalogId(null);
                setFormNalog({ ...emptyNalog });
                showToast('success', 'Nalog sačuvan!');
            } else { showToast('warn', row?.message || 'Greška'); }
        } catch (e) { showToast('error', e?.response?.data?.message || 'Greška'); }
    };

    const applyDanHeader = (row, p) => ({
        ...p,
        dnevnica_ukupno: row.DnevnicaUkupno ?? p.dnevnica_ukupno,
        radnih_dana: row.RadnihDana ?? p.radnih_dana,
    });

    /* toggle dan — za postojeće: ciklus 0→0.5→1.0→0; za prazne dane: kreira red u DB sa 0.5 */
    const handleToggleDan = async (danRow) => {
        if (isLocked) return;
        if (danRow._empty) {
            try {
                const result = await api({ step: 'CREATE_DAN', id: obracunId, dat_od: danRow.datum, koeficijent: 0.5 });
                const row = Array.isArray(result) ? result[0] : result;
                if (row?.ID) {
                    setDani(prev => [...prev, { id: row.ID, datum: row.datum, datumPrikaz: row.datumPrikaz, koeficijent: row.koeficijent, tip_dan: null }]);
                    setFormHeader(p => applyDanHeader(row, p));
                }
            } catch { showToast('error', 'Greška pri dodavanju dana'); }
            return;
        }
        const nextKoef = danRow.koeficijent >= 1.0 ? 0.0 : danRow.koeficijent >= 0.5 ? 1.0 : 0.5;
        try {
            const result = await api({ step: 'SAVE_DAN', id_dan_row: danRow.id, koeficijent: nextKoef });
            const row = Array.isArray(result) ? result[0] : result;
            setDani(prev => prev.map(d => d.id === danRow.id ? { ...d, koeficijent: nextKoef } : d));
            if (row) setFormHeader(p => applyDanHeader(row, p));
        } catch { showToast('error', 'Greška pri ažuriranju dana'); }
    };

    /* EDIT ISPLATA — popuni formu iz postojećeg reda */
    const handleEditIsplata = (row) => {
        setSelectedIsplataId(row.id);
        setFormIsplata({
            datum_isplate: row.datum ? new Date(row.datum) : null,
            opis_isplate: row.opis || '',
            tip: row.tip,
            iznos_eur_isp: Number(row.iznos_eur || 0),
            iznos_rsd_isp: Number(row.iznos_rsd || 0),
        });
    };

    /* ADD / SAVE ISPLATA */
    const handleAddIsplata = async () => {
        setIsplataSubmitted(true);
        if (!formIsplata.datum_isplate) return;

        const tipLabel = tipIsplateDB.find(t => t.value === formIsplata.tip)?.label || null;

        if (!formIsplata.iznos_eur_isp && !formIsplata.iznos_rsd_isp)
            return showToast('warn', 'Bar jedan iznos (EUR ili RSD) mora biti veći od 0!');

        /* Isplata (plata) = jedinstvena isplata zarade za obračun — sme postojati samo jedna po obračunu */
        if (tipLabel === 'Isplata (plata)'
            && isplate.some(i => i.tipNaziv === 'Isplata (plata)' && i.id !== selectedIsplataId)) {
            return showToast('warn', 'Već postoji isplata zarade (Isplata (plata)) za ovaj obračun!');
        }

        const isEdit = !!selectedIsplataId;
        try {
            const result = await api({
                step: isEdit ? 'UPDATE_ISPLATA' : 'INSERT_ISPLATA',
                id: obracunId, id_isplata: selectedIsplataId,
                datum_isplate: toUtcIso(formIsplata.datum_isplate),
                opis_isplate: formIsplata.opis_isplate,
                tip_isplate: formIsplata.tip,
                iznos_eur_isp: formIsplata.iznos_eur_isp,
                iznos_rsd_isp: formIsplata.iznos_rsd_isp,
            });
            const row = Array.isArray(result) ? result[0] : result;
            if (row?.ID) {
                const updated = {
                    id: row.ID, datum: toUtcIso(formIsplata.datum_isplate),
                    datumPrikaz: formIsplata.datum_isplate?.toLocaleDateString('sr-Latn-RS'),
                    opis: formIsplata.opis_isplate,
                    tip: formIsplata.tip,
                    tipNaziv: tipLabel,
                    iznos_eur: formIsplata.iznos_eur_isp,
                    iznos_rsd: formIsplata.iznos_rsd_isp,
                };
                setIsplate(prev => isEdit
                    ? prev.map(i => i.id === row.ID ? updated : i)
                    : [...prev, updated]);
                const defTip = tipIsplateDB.find(t => t.label === 'Isplata (plata)')?.value || null;
                setFormIsplata({ ...emptyIsplata, tip: defTip });
                setSelectedIsplataId(null);
                setIsplataSubmitted(false);
                showToast('success', isEdit ? 'Isplata izmenjena!' : 'Isplata dodata!');
            } else {
                showToast('warn', row?.message || 'Greška');
            }
        } catch (e) { showToast('error', e?.response?.data?.message || 'Greška'); }
    };

    /* CANCEL EDIT ISPLATA */
    const handleCancelEditIsplata = () => {
        const defTip = tipIsplateDB.find(t => t.label === 'Isplata (plata)')?.value || null;
        setFormIsplata({ ...emptyIsplata, tip: defTip });
        setSelectedIsplataId(null);
        setIsplataSubmitted(false);
    };

    /* DELETE ISPLATA */
    const handleDeleteIsplata = (id) => {
        confirmDialog({
            message: 'Obriši ovu isplatu?', acceptLabel: 'Da', rejectLabel: 'Ne',
            icon: 'pi pi-info-circle', acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    const result = await api({ step: 'DELETE_ISPLATA', id_isplata: id });
                    const row = Array.isArray(result) ? result[0] : result;
                    if (row?.message === 'Isplata obrisana!') {
                        setIsplate(prev => prev.filter(i => i.id !== id));
                        showToast('success', 'Isplata obrisana');
                    } else {
                        showToast('warn', row?.message || 'Greška pri brisanju isplate');
                    }
                } catch { showToast('error', 'Greška pri brisanju isplate'); }
            },
        });
    };

    /* CLOSE */
    const handleClose = () => {
        if (!isplate.some(i => i.tipNaziv === 'Isplata (plata)')) {
            return showToast('warn', 'Obračun se ne može zatvoriti bez unete isplate zarade (Isplata (plata))!');
        }

        confirmDialog({
            message: 'Zatvori obračun? Nakon zatvaranja nije moguće editovanje.',
            acceptLabel: 'Da', rejectLabel: 'Ne',
            icon: 'pi pi-info-circle', acceptClassName: 'p-button-warning',
            accept: async () => {
                try {
                    const result = await api({ step: 'CLOSE', id: obracunId, saldo_konacni: saldo, dug_konacni: runningDug });
                    const row = Array.isArray(result) ? result[0] : result;
                    if (row?.ID) { setObracunStatusNaziv('ZATVOREN'); showToast('success', 'Obračun zatvoren!'); }
                    else { showToast('warn', row?.message || 'Greška'); }
                } catch (e) { showToast('error', e?.response?.data?.message || 'Greška'); }
            },
        });
    };

    const handleUnlock = () => {
        confirmDialog({
            message: 'Otključaj zatvoren obračun? Obračun se vraća u status AKTIVAN i može se ponovo editovati.',
            acceptLabel: 'Da', rejectLabel: 'Ne',
            icon: 'pi pi-unlock', acceptClassName: 'p-button-info',
            accept: async () => {
                try {
                    const result = await api({ step: 'UNLOCK', id: obracunId });
                    const row = Array.isArray(result) ? result[0] : result;
                    if (row?.ID) { setObracunStatusNaziv('AKTIVAN'); showToast('success', 'Obračun otključan!'); }
                    else { showToast('warn', row?.message || 'Greška'); }
                } catch (e) { showToast('error', e?.response?.data?.message || 'Greška'); }
            },
        });
    };

    /* DELETE obračuna */
    const handleDelete = () => {
        confirmDialog({
            message: 'Obriši ovaj obračun?', acceptLabel: 'Da', rejectLabel: 'Ne',
            icon: 'pi pi-info-circle', acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    const result = await api({ step: 'DELETE', id: obracunId });
                    const row = Array.isArray(result) ? result[0] : result;
                    showToast(row?.message?.includes('Ne može') ? 'warn' : 'success', row?.message);
                    if (!row?.message?.includes('Ne može')) {
                        setObracunId(null); setObracunStatusNaziv(null);
                        setFormHeader({ ...emptyHeader }); setNalozi([]); setDani([]); setIsplate([]);
                    }
                } catch (e) { showToast('error', e?.response?.data?.message || 'Greška'); }
            },
        });
    };

    /* ADD BONUS */
    const handleAddBonus = async () => {
        setBonusSubmitted(true);
        if (!formBonus.id_obracun_nalog) return;
        if (!formBonus.id_sifarnik && !formBonus.opis_bonus?.trim()) return;
        try {
            const result = await api({
                step: 'INSERT_BONUS', id: obracunId,
                id_sifarnik: formBonus.id_sifarnik || null,
                id_obracun_nalog: formBonus.id_obracun_nalog || null,
                opis_bonus: formBonus.opis_bonus,
                iznos_eur_bon: formBonus.iznos_eur_bon,
            });
            const row = Array.isArray(result) ? result[0] : result;
            if (row?.ID) {
                const naloga = nalozi.find(n => n.id === formBonus.id_obracun_nalog);
                setBonusi(prev => [...prev, {
                    id: row.ID, id_sifarnik: formBonus.id_sifarnik,
                    id_obracun_nalog: formBonus.id_obracun_nalog, br_naloga: naloga?.br_naloga || null,
                    opis: formBonus.opis_bonus, iznos_eur: formBonus.iznos_eur_bon,
                }]);
                if (formBonus.id_obracun_nalog) {
                    setNalozi(prev => prev.map(n => n.id === formBonus.id_obracun_nalog
                        ? { ...n, bonus_dodatni_eur: Number(n.bonus_dodatni_eur || 0) + Number(formBonus.iznos_eur_bon || 0) }
                        : n
                    ));
                }
                setFormBonus({ id_sifarnik: null, id_obracun_nalog: null, opis_bonus: '', iznos_eur_bon: 0 });
                setFilteredBonusiSifarnikPlate([]);
                setBonusSubmitted(false);
                showToast('success', 'Bonus dodat!');
            } else { showToast('warn', row?.message || 'Greška'); }
        } catch (e) { showToast('error', e?.response?.data?.message || 'Greška'); }
    };

    const handleBonusSelect = (b) => {
        setSelectedBonusId(prev => {
            const next = String(prev) === String(b.id) ? null : b.id;
            if (next !== null) {
                setFormBonus({ id_sifarnik: b.id_sifarnik || null, id_obracun_nalog: b.id_obracun_nalog || null, opis_bonus: b.opis, iznos_eur_bon: b.iznos_eur });
                fetchSifarnikForNalog(b.id_obracun_nalog);
            } else {
                setFormBonus({ id_sifarnik: null, id_obracun_nalog: null, opis_bonus: '', iznos_eur_bon: 0 });
                setFilteredBonusiSifarnikPlate([]);
            }
            return next;
        });
    };

    /* UPDATE BONUS */
    const handleUpdateBonus = async () => {
        if (!formBonus.id_sifarnik && !formBonus.opis_bonus?.trim()) return showToast('warn', 'Opis bonusa je obavezan');
        try {
            const result = await api({
                step: 'UPDATE_BONUS', id_bonus: selectedBonusId,
                id_sifarnik: formBonus.id_sifarnik || null,
                id_obracun_nalog: formBonus.id_obracun_nalog || null,
                opis_bonus: formBonus.opis_bonus,
                iznos_eur_bon: formBonus.iznos_eur_bon,
            });
            const row = Array.isArray(result) ? result[0] : result;
            if (row?.ID) {
                await loadObracun(obracunId);
                setFormBonus({ id_sifarnik: null, id_obracun_nalog: null, opis_bonus: '', iznos_eur_bon: 0 });
                setFilteredBonusiSifarnikPlate([]);
                setBonusSubmitted(false);
                setSelectedBonusId(null);
                showToast('success', 'Bonus ažuriran!');
            } else { showToast('warn', row?.message || 'Greška'); }
        } catch (e) { showToast('error', e?.response?.data?.message || 'Greška'); }
    };

    /* DELETE BONUS */
    const handleDeleteBonus = (id) => {
        confirmDialog({
            message: 'Obriši ovaj bonus?', acceptLabel: 'Da', rejectLabel: 'Ne',
            icon: 'pi pi-info-circle', acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await api({ step: 'DELETE_BONUS', id_bonus: id });
                    await loadObracun(obracunId);
                    setSelectedBonusId(null);
                    setFormBonus({ id_sifarnik: null, id_obracun_nalog: null, opis_bonus: '', iznos_eur_bon: 0 });
                    showToast('success', 'Bonus obrisan');
                } catch { showToast('error', 'Greška pri brisanju bonusa'); }
            },
        });
    };

    /* DELETE iz PREGLED taba */
    const handleDeleteFromPregled = () => {
        if (!selectedPregledId) return;
        confirmDialog({
            message: 'Obriši izabrani obračun?', acceptLabel: 'Da', rejectLabel: 'Ne',
            icon: 'pi pi-info-circle', acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    const result = await api({ step: 'DELETE', id: selectedPregledId });
                    const row = Array.isArray(result) ? result[0] : result;
                    if (row?.message?.includes('Ne može')) { showToast('warn', row.message); return; }
                    setPregledData(prev => prev.filter(r => r.id !== selectedPregledId));
                    setSelectedPregledId(null);
                    showToast('success', 'Obračun obrisan!');
                } catch (e) { showToast('error', e?.response?.data?.message || 'Greška'); }
            },
        });
    };

    /* computed totals */
    const totalNaloziIznos   = nalozi.reduce((s, n) => s + Number(n.iznos_eur || 0), 0);
    const totalNaloziBonus   = nalozi.reduce((s, n) => s + Number(n.bonus_iznos_eur || 0), 0);
    const totalNaloziOstatak = nalozi.reduce((s, n) => s + Number(n.ostatak_eur || 0), 0);
    const totalDaniKoef      = dani.reduce((s, d) => s + Number(d.koeficijent || 0), 0);
    /* pun kalendar od genDnevniceOd do genDnevniceDo — svaki dan vidljiv, aktivni iz DaniDB naznačeni */
    const daniWeeks = (() => {
        const isoDow = d => { const dow = d.getDay(); return dow === 0 ? 7 : dow; };
        const start = genDnevniceOd ? new Date(genDnevniceOd) : null;
        const end   = genDnevniceDo ? new Date(genDnevniceDo) : null;
        if (!start || !end) return [];
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 0);

        const daniMap = {};
        dani.forEach(d => { const k = d.datum?.slice(0, 10); if (k) daniMap[k] = d; });

        const weeks = [];
        let week = new Array(isoDow(start) - 1).fill(null);
        const cur = new Date(start);
        while (cur <= end) {
            const key = `${cur.getFullYear()}-${String(cur.getMonth()+1).padStart(2,'0')}-${String(cur.getDate()).padStart(2,'0')}`;
            const dp  = `${String(cur.getDate()).padStart(2,'0')}.${String(cur.getMonth()+1).padStart(2,'0')}.`;
            week.push(daniMap[key] || { _empty: true, datum: key, datumPrikaz: dp, koeficijent: 0, tip_dan: null });
            if (week.length === 7) { weeks.push(week); week = []; }
            cur.setDate(cur.getDate() + 1);
        }
        if (week.length) { while (week.length < 7) week.push(null); weeks.push(week); }
        return weeks;
    })();
    const totalBonusDod      = bonusi.reduce((s, b) => s + Number(b.iznos_eur || 0), 0);
    const totalNaloziTrosak  = nalozi.reduce((s, n) => s + Number(n.trosak_gotovina_eur || 0), 0);
    const saldoPrethodniVal = Number(formHeader.saldo_prethodni || 0);
    const saldoPrethodniLabel = (() => {
        if (!genMesec || !genGodina) return null;
        const pm = genMesec === 1 ? 12 : genMesec - 1;
        const py = genMesec === 1 ? genGodina - 1 : genGodina;
        return `STANJE IZ ${String(pm).padStart(2, '0')}.${py}.`;
    })();
    const naloziDisplay = (saldoPrethodniVal && saldoPrethodniLabel)
        ? [{ id: '__saldo__', br_naloga: saldoPrethodniLabel, iznos_eur: saldoPrethodniVal, _isSaldo: true }, ...nalozi]
        : nalozi;
    /* standalone akontacije: izlaz(221) - ulaz(222) */
    const netAkontStandalone = akontacijeStandalone.reduce((s, a) =>
        s + (a.id_vrsta_transakcije === 221 ? Number(a.Iznos || 0) : -Number(a.Iznos || 0)), 0);

    /* konverzija zaglavlja u EUR */
    const zagKurs   = Number(formHeader.kurs) || 1;
    const isEurZag  = !formHeader.valuta_zaglavlja || formHeader.valuta_zaglavlja === EUR_ID;
    const toEur     = (v) => isEurZag ? Number(v || 0) : Number(v || 0) / zagKurs;
    /* polja sa sopstvenom valutom (Bonus G, Telefon, Gorivo, Isplata putnih troškova) — konverzija
       zavisi od valute IZABRANE za to polje, ne od valute zaglavlja */
    const toEurField = (v, valutaId) => (!valutaId || valutaId === EUR_ID) ? Number(v || 0) : Number(v || 0) / zagKurs;

    /* ZARADA bruto = km iznosi + bonusi + dnevnice, BEZ odbijanja minimalca — isti broj kao "KM:" red
       u zaglavlju detaljnog excel izvoza (vidi zaradaEur u exportSviMeseci) */
    const minimalacEur = toEurField(formHeader.minimalac, formHeader.minimalac_valuta);

    /* TipTransakcije IDs iz modgen (grupa 46): rn=1=Dodatak, rn=2=Odbitak */
    const idTipDodatak = zaglavljeTipDB[0]?.value ?? null;
    const idTipOdbitak = zaglavljeTipDB[1]?.value ?? null;

    /* zaglavlje stavke — Isplate idu u zaradu bruto, Odbitci idu u odbiciZaglavlja */
    const zaglavljeIsplate = zaglavljeStavke
        .filter(s => idTipDodatak !== null ? s.TipTransakcije === idTipDodatak : false)
        .reduce((sum, s) => { const v = zaglavljeVrednosti[s.value]; return v ? sum + toEurField(v.iznos, v.valuta_id) : sum; }, 0);
    const zaglavljeOdbitci = zaglavljeStavke
        .filter(s => idTipOdbitak !== null ? s.TipTransakcije === idTipOdbitak : false)
        .reduce((sum, s) => { const v = zaglavljeVrednosti[s.value]; return v ? sum + toEurField(v.iznos, v.valuta_id) : sum; }, 0);

    const zaradaBruto = totalNaloziIznos + totalNaloziBonus
        + toEur(formHeader.dnevnica_ukupno)
        + zaglavljeIsplate
        + totalBonusDod;
    /* ZARADA (kartica) = bruto − minimalac (isto kao "Total Iznos EUR" u detaljnom excel izvozu,
       gde je ISPLATA MINIMALCA takođe negativna stavka u istoj koloni) */
    const zarada = zaradaBruto - minimalacEur;
    /* ukupno dužan po akontacijama = ostatak tura (EUR + RSD→EUR) + standalone van ture */
    const sumOstEurTrips = nalozi.reduce((s, n) => s + Number(n.ostatak_eur || 0) - Number(n.trosak_gotovina_eur || 0), 0);
    const sumOstRsdTrips = nalozi.reduce((s, n) => s + Number(n.akontacija_rsd || 0) - Number(n.razduzenje_rsd || 0), 0);
    const ukupnoDuzan = sumOstEurTrips + (sumOstRsdTrips / zagKurs) + netAkontStandalone;

    /* tipovi isplate (bez podtipa — svaki tip je sad samostalan):
       - Isplata (plata): AVANS, skida se direktno sa SALDA (ne kroz ODBICI)
       - Odbitak: normalan odbitak — utiče SAMO na ODBICI karticu (umanjuje SALDO kroz odbitci),
         NE prikazuje se i NE utiče na DUG karticu
       - Vraćanje duga: bypass ODBICI, direktno umanjuje i SALDO i DUG karticu
       - Pozajmica: Dug-tipa, ali umanjuje SAMO DUG karticu, ne SALDO */
    const isPlataIsplata  = i => i.tipNaziv === 'Isplata (plata)';
    const isVracanjeDuga  = i => i.tipNaziv === 'Vraćanje duga';
    const isPozajmica     = i => i.tipNaziv === 'Pozajmica';

    /* isplate koje odbijaju ODBITCI: SVE OSIM Isplata (plata), Vraćanje duga i Pozajmica — Odbitak
       OSTAJE u ovoj sumi (kao i do sada, normalan odbitak iz zarade); Isplata (plata) nije "odbitak",
       to je AVANS, prikazuje se posebno i skida se direktno sa SALDA */
    const totalIsplate = isplate.reduce((s, i) =>
        (isPlataIsplata(i) || isVracanjeDuga(i) || isPozajmica(i)) ? s : s + Number(i.iznos_eur || 0) + Number(i.iznos_rsd || 0) / zagKurs, 0);
    const avansPlata = isplate.reduce((s, i) =>
        isPlataIsplata(i) ? s + Number(i.iznos_eur || 0) + Number(i.iznos_rsd || 0) / zagKurs : s, 0);
    /* Vraćanje duga — bypass ODBICI, direktno se skida sa SALDA (van odbitci) */
    const totalVracanjeDuga = isplate.reduce((s, i) =>
        isVracanjeDuga(i) ? s + Number(i.iznos_eur || 0) + Number(i.iznos_rsd || 0) / zagKurs : s, 0);
    const totalPozajmica = isplate.reduce((s, i) =>
        isPozajmica(i) ? s + Number(i.iznos_eur || 0) + Number(i.iznos_rsd || 0) / zagKurs : s, 0);
    /* DUG kartica prati SAMO Vraćanje duga i Pozajmicu — Odbitak ne dotiče DUG, samo ODBICI (gore) —
       kroz mesece (dug_prethodni je prenet sa zatvaranja prethodnog meseca preko dug_konacni).
       Pozitivno = postoji dug (zaposleni duguje firmi), negativno = zaposleni je u plusu.
       Pozajmica (nova pozajmica firme zaposlenom) UVEĆAVA dug, Vraćanje duga (otplata) UMANJUJE dug. */
    const totalDug = totalPozajmica - totalVracanjeDuga;
    const runningDug = toEur(formHeader.dug_prethodni) + totalDug;

    /* ODBITCI (kartica na UI) = ostatak tura/akontacija + isplate (Plata/Vraćanje duga/Pozajmica
       isključeni, Odbitak uračunat) — telefon/gorivo/putni troškovi iz zaglavlja se NE prikazuju u
       ODBICI kartici; ti iznosi iz zaglavlja se uračunavaju direktno u SALDO ispod */
    const odbitci = ukupnoDuzan + totalIsplate;
    /* iznosi iz zaglavlja koji ne idu u ODBICI karticu, ali ipak umanjuju SALDO */
    const odbiciZaglavlja = zaglavljeOdbitci;
    /* SALDO = ukupno dugovanje pre isplate zarade, umanjeno za AVANS (Isplata (plata)) i Vracanje
       duga (direktno, van odbitci) — Odbitak je već uračunat kroz odbitci (gore), Pozajmica NE utiče
       na SALDO, samo na DUG karticu — ostatak (KONAČNO) prelazi u saldo_prethodni narednog meseca
       preko saldo_konacni (vidi handleClose) */
    const saldoPreAvansa = toEur(formHeader.saldo_prethodni) + zarada - odbitci - odbiciZaglavlja - totalVracanjeDuga;
    const saldo = saldoPreAvansa - avansPlata;

    /* Excel export — PREGLED */
    const exportPregledExcel = async () => {
        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet('Obračun plate');
        const headers = ['Vozač', 'Dat. od', 'Dat. do', 'Status', 'Kurs', 'Dnevnice €', 'Napomena'];
        const hRow = ws.addRow(headers);
        hRow.font = { bold: true };
        hRow.eachCell(cell => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEFEFEF' } };
            cell.border = { top:{style:'medium'}, left:{style:'medium'}, bottom:{style:'medium'}, right:{style:'medium'} };
        });
        (pregledData || []).forEach(r => {
            const dnevniceLabel = r.dnevnica_ukupno != null ? `${r.dnevnica_ukupno}${r.dnevnica_rus_fix ? ` (sadrži RUS turu${r.dnevnica_rus_dani ? `, ${r.dnevnica_rus_dani} dana` : ''})` : ''}` : r.dnevnica_ukupno;
            const row = ws.addRow([r.ZaposleniNaziv, r.dat_od, r.dat_do, r.StatusNaziv, r.kurs, dnevniceLabel, r.napomena]);
            row.eachCell(cell => {
                cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
            });
        });
        ws.columns.forEach(col => {
            let max = 10;
            col.eachCell(cell => { if (cell.value) max = Math.max(max, cell.value.toString().length); });
            col.width = max + 2;
        });
        const dt = new Date().toLocaleString('sr-RS', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit', timeZone:'Europe/Belgrade' }).replace(/,/g,'');
        const buffer = await wb.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Obračun plate - ${company?.companyName || ''} - ${dt}.xlsx`);
    };

    /* Excel export — svi meseci za zaposlenog (svaki mesec = jedan sheet, jedna tabela) */
    const exportSviMeseci = async () => {
        if (!genZap) return showToast('warn', 'Izaberi zaposlenog pre štampanja');
        showToast('info', 'Učitavanje podataka...');
        try {
            const sviObracuni = await api({ step: 'GET_PREGLED', id_zaposleni: genZap });
            if (!Array.isArray(sviObracuni) || sviObracuni.length === 0)
                return showToast('warn', 'Nema obračuna za ovog zaposlenog');

            const sorted = [...sviObracuni].sort((a, b) => new Date(a.mesec) - new Date(b.mesec));
            const last6 = sorted.slice(-6);
            const detalji = [];
            for (const op of last6) {
                const data = await api({ step: 'GET_OBRACUN', id: op.id });
                detalji.push(data);
            }

            const wb = new ExcelJS.Workbook();
            const zapNazivStr = zaposleniDB.find(z => z.value === genZap)?.label || '';

            const thin     = { style: 'thin' };
            const med      = { style: 'medium' };
            const bThin    = { top: thin, left: thin,  bottom: thin,  right: thin  };
            const bMed     = { top: med,  left: med,   bottom: med,   right: med   };
            const bMedTop  = { top: med,  left: thin,  bottom: thin,  right: thin  };
            const fillYel  = { type:'pattern', pattern:'solid', fgColor:{ argb:'FFFFF3CD' } };
            const fillPink = { type:'pattern', pattern:'solid', fgColor:{ argb:'FFFCE4EC' } };
            const fillBlue = { type:'pattern', pattern:'solid', fgColor:{ argb:'FFE3F2FD' } };

            for (const detail of detalji) {
                const h = detail?.HeaderDB?.[0];
                if (!h) continue;

                const mesecDate  = new Date(h.mesec);
                const sheetName  = `${String(mesecDate.getMonth()+1).padStart(2,'0')}.${mesecDate.getFullYear()}`;
                const ws         = wb.addWorksheet(sheetName);

                /*
                 * 12 kolona: główna tabela koristi 1-6, pregled akontacija 1-11,
                 * kolona 12 = grand total EUR za pregled akontacija
                 */
                ws.columns = [
                    { width: 34 }, // 1: OPIS POSLA / DATUM
                    { width: 18 }, // 2: VOZAČ / BR NALOGA
                    { width: 12 }, // 3: KM / ZAD EUR
                    { width: 12 }, // 4: IZNOS EUR / ZAD RSD
                    { width: 12 }, // 5: IZNOS RSD / YES MONEY
                    { width: 12 }, // 6: IZNOS DUGA / RAZD EUR
                    { width: 12 }, // 7: RAZD RSD
                    { width: 12 }, // 8: TROS EUR
                    { width: 12 }, // 9: TROS RSD
                    { width: 13 }, // 10: OSTAO DUŽAN EUR
                    { width: 13 }, // 11: OSTAO DUŽAN RSD
                    { width: 15 }, // 12: GRAND TOTAL EUR
                ];

                const nalozi_xl           = detail?.NaloziDB              || [];
                const isplate_xl          = detail?.IsplateDB             || [];
                const bonusi_xl           = detail?.BonusiDB              || [];
                const dani_xl             = detail?.DaniDB                || [];
                const akontacijeStandalone = detail?.AkontacijeStandaloneDB || [];

                const totalKm        = nalozi_xl.reduce((s,n) => s + Number(n.km||0) + Number(n.dodatni_km||0), 0);
                const radnih_dana_xl = dani_xl.reduce((s,d) => s + Number(d.koeficijent||0), 0);

                /* konverzija zaglavlja u EUR za Excel (valuta_zaglavlja → EUR) */
                const zagValuta_h  = h.valuta_zaglavlja || EUR_ID;
                const zagKurs_h    = Number(h.kurs || 1) || 1;
                const isEurZag_h   = zagValuta_h === EUR_ID;
                const xlToEur_h    = (v) => isEurZag_h ? Number(v||0) : Number(v||0) / zagKurs_h;
                /* polja sa sopstvenom valutom (Bonus G, Telefon, Gorivo, Isplata putnih troškova) —
                   konverzija u EUR zavisi od valute IZABRANE za to polje, ne od valute zaglavlja */
                const xlToEurField_h = (v, valutaId) => (!valutaId || valutaId === EUR_ID) ? Number(v||0) : Number(v||0) / zagKurs_h;

                /* ukupna zarada: km iznosi + bonusi + dnevnice */
                const zaradaEur = nalozi_xl.reduce((s,n) => s + Number(n.iznos_eur||0) + Number(n.bonus_iznos_eur||0), 0)
                    + xlToEur_h(h.dnevnica_ukupno)
                    + xlToEurField_h(h.bonus_g, h.bonus_g_valuta)
                    + bonusi_xl.reduce((s,b) => s + Number(b.iznos_eur||0), 0);

                /* isplate — razdvojene po tipu i valuti u kojoj su unete u bazu:
                   - Isplata (plata), Odbitak     -> aktivni iznos (kolona EUR ili RSD, kako je uneto, nikad konvertovano);
                     Odbitak NE dotiče kolonu IZNOS DUGA (samo ODBICI/aktivni iznos)
                   - Vraćanje duga                -> umanjuje aktivni iznos (kolona EUR ili RSD, kako je uneto)
                     I dodatno se prikazuje kao umanjenje (-) u koloni IZNOS DUGA (EUR; konvertovano ako je uneto u RSD)
                   - Pozajmica                    -> SAMO kolona IZNOS DUGA, kao uvećanje (+) duga (posebna računica, ne dira IZNOS EUR/RSD) */
                const isDugFull_xl   = i => i.tipNaziv === 'Vraćanje duga';
                const isPozajmica_xl = i => i.tipNaziv === 'Pozajmica';
                const isDug = i => isDugFull_xl(i) || isPozajmica_xl(i);
                const isplate_aktivni_rsd = isplate_xl.filter(i => !isDug(i) && Number(i.iznos_rsd||0) !== 0 && Number(i.iznos_eur||0) === 0);
                const isplate_aktivni_eur = isplate_xl.filter(i => !isDug(i) && Number(i.iznos_eur||0) !== 0);
                const isplate_dug         = isplate_xl.filter(isDugFull_xl);
                const isplate_pozajmica   = isplate_xl.filter(isPozajmica_xl);

                /* ---- redovi zaglavlja ---- */
                const r1 = ws.addRow([company?.companyName || '']);
                r1.getCell(1).font = { bold: true, size: 13 };
                ws.mergeCells(1,1,1,12);

                const r2 = ws.addRow([`Vozač: ${zapNazivStr}`, '', '', `Period: ${h.dat_od} — ${h.dat_do}`]);
                r2.getCell(1).font = { bold: true };
                ws.mergeCells(2,1,2,3);
                ws.mergeCells(2,4,2,12);

                ws.addRow([`Kurs EUR: ${Number(h.kurs||0).toFixed(4)}`, '', '', '', `Status: ${h.StatusNaziv||''}`,
                    h.prijavljen_od ? `PRIJAVLJEN OD: ${h.id_zaposleni}, ${h.prijavljen_od}` : '']);
                ws.addRow(['', '', `Radnih dana: ${radnih_dana_xl}`, '',
                    h.dnevnica_rus_fix ? `Dana na RUS turi (fix, van obračuna): ${h.dnevnica_rus_dani || 0}` : '', '']);
                ws.addRow([]);

                /* red 5: KM i zarada (info iznad tabele) */
                const r5 = ws.addRow(['', '', 'KM:', zaradaEur, '', '']);
                r5.getCell(3).font = { bold: true };
                r5.getCell(4).font = { bold: true };
                r5.getCell(4).numFmt = '#,##0.00 "€"';

                /* ===== TABELA (desno od glavne): PREGLED DNEVNICA — naslov + grupni header.
                   Valuta "U zemlji" kolone se uzima sa STVARNO konfigurisane valute domaće dnevnice
                   (dnevnica_rsd_valuta, iz finance.Dnevnice preko trip.IzracunajDnevnicu) — NE nagađa se
                   preko id_drzava firme, jer je za neke firme domaća dnevnica takođe u EUR. */
                const dnCol = { tura: 8, eur: 9, rsd: 10, grand: 11 };
                const domesticValutaSample = nalozi_xl.find(n => n.dnevnica_rsd_valuta)?.dnevnica_rsd_valuta;
                const domesticIsEur = domesticValutaSample ? domesticValutaSample !== 'RSD' : Number(company?.companyCountryID) !== 1;
                const domLabel = domesticIsEur ? 'Iznos EUR' : 'Iznos RSD';

                r5.getCell(dnCol.tura).value = 'PREGLED DNEVNICA';
                r5.getCell(dnCol.tura).font  = { bold: true, size: 12 };
                ws.mergeCells(r5.number, dnCol.tura, r5.number, dnCol.grand);

                /* grupni naslovi iznad kolona valuta — addRow sekvencijalno (NE getRow sa eksplicitnim
                   brojem reda) da se ne "preskoči" napred i ostavi prazan razmak u glavnoj tabeli levo */
                const dnGroupRow = ws.addRow([]);
                dnGroupRow.getCell(dnCol.eur).value = 'INO';
                dnGroupRow.getCell(dnCol.rsd).value = 'U zemlji';
                [dnCol.eur, dnCol.rsd].forEach(c => {
                    dnGroupRow.getCell(c).font = { bold: true };
                    dnGroupRow.getCell(c).alignment = { horizontal: 'center' };
                });

                /* red header tabele — KM kolona sadrži ukupan broj km */
                const mainHdr = ws.addRow(['OPIS POSLA', 'VOZAČ', Math.round(totalKm), 'IZNOS EUR', 'IZNOS RSD', 'IZNOS DUGA']);
                mainHdr.font = { bold: true };
                mainHdr.eachCell((cell, col) => {
                    cell.fill   = col === 3 ? fillPink : fillBlue;
                    cell.border = bMed;
                });
                mainHdr.getCell(3).numFmt = '0';

                ['TURA', 'Iznos EUR', domLabel].forEach((label, i) => {
                    const cell = mainHdr.getCell(dnCol.tura + i);
                    cell.value  = label;
                    cell.font   = { bold: true };
                    cell.fill   = fillBlue;
                    cell.border = bMed;
                });

                /* ---- praćenje zbira po kolonama za TOTAL red ----
                   sumRsd      = IZNOS RSD koji OSTAJE u RSD (ne prebacuje se u EUR) — npr. Bonus G; ide u TOTAL.
                   sumRsdConv  = IZNOS RSD koji SE prebacuje u EUR (sve ostalo) — ne ide u TOTAL RSD, već se
                                 prikazuje zbirno u MENJANJE redu (kolona RSD) i konvertovano u MENJANJE (kolona EUR) */
                let sumEur = 0, sumRsd = 0, sumDuga = 0, sumRsdConv = 0;

                const addRow = (opis, km, eur, rsd, duga, opts = {}) => {
                    const r = ws.addRow([
                        opis,
                        opts.vozac || '',
                        km   != null ? km   : '',
                        eur  != null ? eur  : '',
                        rsd  != null ? rsd  : '',
                        duga != null ? duga : '',
                    ]);
                    if (opts.bold) r.font = { bold: true };
                    if (opts.fill)        r.eachCell(cell => { cell.fill = opts.fill; cell.border = bMed; });
                    else if (opts.borderTop) r.eachCell(cell => { cell.border = bMedTop; });
                    else                  r.eachCell(cell => { cell.border = bThin; });
                    if (km   != null) r.getCell(3).numFmt = '#,##0';
                    if (eur  != null) { r.getCell(4).numFmt = '#,##0.00 "€"'; sumEur += Number(eur); }
                    if (rsd  != null) {
                        r.getCell(5).numFmt = '#,##0.00 "Din."';
                        if (opts.convert) {
                            sumRsdConv += Number(rsd); /* za MENJANJE prikaz */
                            sumRsd     += Number(rsd); /* za TOTAL RSD */
                        } else if (!opts.noRsdSum) {
                            sumRsd += Number(rsd);
                        }
                    }
                    if (duga != null) { r.getCell(6).numFmt = '#,##0.00 "€"'; sumDuga += Number(duga); }
                    return r;
                };

                /* saldo_prethodni i dug_prethodni prikazani su u zaglavlju forme — ne prikazuju se ovde */
                const dugPrethodni = xlToEur_h(h.dug_prethodni);
                if (dugPrethodni !== 0) {
                    const prevDate = new Date(mesecDate.getFullYear(), mesecDate.getMonth()-1, 1);
                    const prevStr  = `${String(prevDate.getMonth()+1).padStart(2,'0')}.${prevDate.getFullYear()}.`;
                    addRow(`STANJE IZ ${prevStr}`, null, null, null, dugPrethodni);
                }

                /* DNEVNICE — osnovica (PERIOD/FIX_MESECNO) razdvojena od Godišnjeg/Bolovanja (h.dnevnica_ukupno = zbir sva tri) */
                const dnevniceGod = xlToEur_h(h.dnevnica_godisnji);
                const dnevniceBol = xlToEur_h(h.dnevnica_bolovanje);
                const dnevnice    = xlToEur_h(h.dnevnica_ukupno) - dnevniceGod - dnevniceBol;
                /* dani bez tip_dan (G/B/R) su dani koji ulaze u PERIOD dnevnice — uvek se prikazuju,
                   bez obzira da li je iznos 0 (npr. kad su svi dani u periodu G/B/R) */
                const daniNormalCount = dani_xl.reduce((s,d) => !d.tip_dan ? s + Number(d.koeficijent||0) : s, 0);
                addRow(`DANI RADA${h.dnevnica_sifarnik_naziv ? ` (${h.dnevnica_sifarnik_naziv})` : ''} (${daniNormalCount} dana):`, null, dnevnice, null, null);

                /* putni nalozi */
                nalozi_xl.forEach(n => {
                    const dodKm = Number(n.dodatni_km || 0);
                    addRow(
                        `${n.br_naloga} od ${n.dat_od} godine${dodKm ? ` (uklj. dodatnih ${dodKm} km)` : ''}`,
                        (Number(n.km||0) + dodKm) || null,
                        Number(n.iznos_eur||0) || null,
                        null, null,
                        { vozac: n.suzaposleni || '' }
                    );
                });

                ws.addRow([]);

                /* isplate aktivnog iznosa unete u RSD (Isplata ili Odbitak+Plata) */
                isplate_aktivni_rsd.forEach(i => {
                    const label = i.datumPrikaz ? `${i.opis} ${i.datumPrikaz}` : (i.opis || 'Isplata');
                    addRow(label, null, null, -Number(i.iznos_rsd), null, { convert: true });
                });

                /* bonusi iz zaglavlja — raw vrednost ide u kolonu (EUR ili RSD) koja odgovara IZABRANOJ valuti polja,
                   bez konverzije (kako je uneto u bazu); u ukupnu zaradu/odbitke se i dalje računa konvertovano u EUR */
                const bonus_g_isEur = !h.bonus_g_valuta || h.bonus_g_valuta === EUR_ID;
                const bonus_g = Number(h.bonus_g || 0);
                if (bonus_g !== 0) addRow('Bonus - G', null, bonus_g_isEur ? bonus_g : null, bonus_g_isEur ? null : bonus_g, null);

                const telefon_isEur = !h.telefon_valuta || h.telefon_valuta === EUR_ID;
                const telefon = Number(h.telefon || 0);
                if (telefon !== 0) addRow('TELEFON:', null, telefon_isEur ? -telefon : null, telefon_isEur ? null : -telefon, null, { convert: true });

                /* gorivo (iz zaglavlja, ručno uneto) */
                const gorivo_isEur = !h.gorivo_valuta || h.gorivo_valuta === EUR_ID;
                const gorivo = Number(h.gorivo_eur || 0);
                if (gorivo !== 0) addRow('GORIVO:', null, gorivo_isEur ? -gorivo : null, gorivo_isEur ? null : -gorivo, null, { convert: true });

                /* ISPLATA MINIMALCA — prikazuje se u koloni koja odgovara valuti u kojoj je minimalna zarada
                   ORIGINALNO sačuvana u bazi (trip.ObracunMinimalnaZarada.Valuta → h.minimalac_valuta), bez
                   konverzije; MENJANJE red ispod kasnije sabira sve RSD stavke (uklj. ovu) i prebacuje u EUR */
                const minimalac_isEur = !h.minimalac_valuta || h.minimalac_valuta === EUR_ID;
                const minimalac    = Number(h.minimalac || 0);
                const isplata_putnih_isEur = !h.isplata_putnih_valuta || h.isplata_putnih_valuta === EUR_ID;
                const isplata_putnih = Number(h.isplata_putnih_troskova || 0);
                if (minimalac !== 0) addRow('ISPLATA MINIMALCA', null, minimalac_isEur ? -minimalac : null, minimalac_isEur ? null : -minimalac, null, { convert: true });
                if (isplata_putnih !== 0) addRow('ISPLATA PUTNIH TROŠKOVA', null, isplata_putnih_isEur ? -isplata_putnih : null, isplata_putnih_isEur ? null : -isplata_putnih, null, { convert: true });

                /* dinamičke zaglavlje stavke — Dodatak = pozitivno, Odbitak = negativno */
                {
                    const zaglMerged = {};
                    (detail?.ZaglavljeAutoVrednostiDB || []).forEach(v => {
                        if (v.iznos !== null) zaglMerged[v.id_stavka] = { iznos: v.iznos, valuta_id: v.valuta_id };
                    });
                    (detail?.ZaglavljeVrednostiDB || []).forEach(v => {
                        zaglMerged[v.id_stavka] = { iznos: v.iznos, valuta_id: v.valuta_id };
                    });
                    zaglavljeStavke.forEach(s => {
                        const v = zaglMerged[s.value];
                        if (!v) return;
                        const iznos = Number(v.iznos || 0);
                        if (iznos === 0) return;
                        const isEur = !v.valuta_id || v.valuta_id === EUR_ID;
                        if (idTipDodatak !== null ? s.TipTransakcije === idTipDodatak : false) {
                            addRow(s.label, null, isEur ? iznos : null, isEur ? null : iznos, null, isEur ? {} : { convert: true });
                        } else {
                            addRow(s.label, null, isEur ? -iznos : null, isEur ? null : -iznos, null, isEur ? {} : { convert: true });
                        }
                    });
                }

                if (dnevniceGod !== 0) addRow('DNEVNICE - GODIŠNJI:', null, dnevniceGod, null, null);
                if (dnevniceBol !== 0) addRow('DNEVNICE - BOLOVANJE:', null, dnevniceBol, null, null);

                /* ostatak od ture = Ostao dužan iz Pregled akontacija: akontacija izlaz(221) − ulaz(222) − trošak
                   (gotovina + gotovina bez računa). Negativno (firma duguje vozaču) automatski ulazi u IZNOS EUR
                   kao dodatak (-ostao je pozitivno), pozitivno (vozač duguje firmi) kao odbitak, isti znak obrt. */
                nalozi_xl.forEach(n => {
                    const ostao = Number(n.ostatak_eur||0) - Number(n.trosak_gotovina_eur||0);
                    if (ostao !== 0) addRow(`OSTATAK OD TURE ${n.br_naloga}`, null, -ostao, null, null);
                });

                /* bonus po nalogu */
                nalozi_xl.forEach(n => {
                    const bon = Number(n.bonus_iznos_eur||0);
                    if (bon !== 0) addRow(`Bonus - ${n.bonus_opis || ''}`, null, bon, null, null);
                });

                /* dodatni bonusi (BonusiDB) */
                bonusi_xl.forEach(b => {
                    const bon = Number(b.iznos_eur||0);
                    if (bon !== 0) addRow(`Bonus - ${b.opis || ''}`, null, bon, null, null);
                });

                ws.addRow([]);

                /* isplate aktivnog iznosa unete u EUR (Isplata ili Odbitak+Plata) — uvek u IZNOS EUR, negativno (već isplaćeno/umanjenje) */
                isplate_aktivni_eur.forEach(i => {
                    const iznos  = Number(i.iznos_eur||0);
                    const label  = i.datumPrikaz ? `${i.opis} ${i.datumPrikaz}` : (i.opis || 'Isplata');
                    addRow(label, null, -iznos, null, null);
                });

                /* Vraćanje duga — umanjuje aktivni iznos (EUR ili RSD, kako je uneto)
                   I se dodatno prikazuje kao umanjenje u koloni IZNOS DUGA (EUR; konvertovano ako je uneto u RSD) */
                isplate_dug.forEach(i => {
                    const eur   = Number(i.iznos_eur||0);
                    const rsd   = Number(i.iznos_rsd||0);
                    const dugEur = eur !== 0 ? eur : (rsd !== 0 ? rsd / zagKurs_h : 0);
                    const label  = i.datumPrikaz ? `${i.opis} ${i.datumPrikaz}` : (i.opis || 'Isplata');
                    if (dugEur === 0) return;
                    if (eur !== 0) addRow(label, null, -eur, null, -dugEur);
                    else addRow(label, null, null, -rsd, -dugEur, { convert: true });
                });

                /* Pozajmica — posebna računica: SAMO kolona IZNOS DUGA, kao uvećanje (+) duga, ne dira IZNOS EUR/RSD */
                isplate_pozajmica.forEach(i => {
                    const eur   = Number(i.iznos_eur||0);
                    const rsd   = Number(i.iznos_rsd||0);
                    const dugEur = eur !== 0 ? eur : (rsd !== 0 ? rsd / zagKurs_h : 0);
                    const label  = i.datumPrikaz ? `${i.opis} ${i.datumPrikaz}` : (i.opis || 'Pozajmica');
                    if (dugEur === 0) return;
                    addRow(label, null, null, null, dugEur);
                });

                /* standalone EUR akontacije (izlaz 221 = ISPLATA, ulaz 222 = POVRAT) */
                akontacijeStandalone.forEach(a => {
                    const iznos = Number(a.Iznos||0);
                    if (iznos === 0) return;
                    const datum = (a.datumPrikaz||'').replace(/\.$/, '');
                    if (a.id_vrsta_transakcije === 221) {
                        addRow(`ISPLATA - ${datum}`, null, -iznos, null, null);
                    } else {
                        addRow(`POVRAT - ${datum}`, null, iznos, null, null);
                    }
                });

                /* MENJANJE — sve što je upisano u IZNOS RSD a podleže konverziji (isplate u RSD, telefon,
                   gorivo, isplata putnih troškova, minimalac...), SEM Bonus G (taj ostaje u RSD, ne menja se),
                   zbirno se prikazuje u OVOM redu: kolona IZNOS RSD = sirov zbir RSD koji se menja,
                   kolona IZNOS EUR = isti zbir konvertovan po kursu obračuna — da TOTAL EUR ispravno obuhvati
                   te stavke, a TOTAL RSD ostane samo ono što se NE konvertuje (npr. Bonus G u RSD) */
                const menjanjeRsd = sumRsdConv;
                const menjanjeEur = menjanjeRsd / zagKurs_h;
                if (menjanjeRsd !== 0 || menjanjeEur !== 0) addRow('MENJANJE', null, menjanjeEur, menjanjeRsd, null, { borderTop: true, noRsdSum: true });

                /* TOTAL */
                const totRow = ws.addRow(['TOTAL', '', '', sumEur, sumRsd, sumDuga]);
                totRow.font = { bold: true };
                totRow.getCell(4).numFmt = '#,##0.00 "€"';
                totRow.getCell(5).numFmt = '#,##0.00 "Din."';
                totRow.getCell(6).numFmt = '#,##0.00 "€"';
                totRow.eachCell(cell => { cell.fill = fillYel; cell.border = bMed; });

                /* ===== TABELA (desno od glavne): PREGLED DNEVNICA — podaci.
                   Popunjava se OVDE (nakon glavne tabele), ne odmah posle header-a — glavna tabela
                   (addRow sekvencijalno) je do sada već prošla kroz dovoljno redova, pa getRow()
                   sa eksplicitnim brojem reda upisuje u POSTOJEĆE redove umesto da "preskoči" napred
                   i ostavi prazan razmak u kolonama A-F (bio je tačno taj bug). */
                let dnSumEur = 0, dnSumRsd = 0;
                nalozi_xl.forEach((n, idx) => {
                    const row = ws.getRow(mainHdr.number + 1 + idx);
                    const eur = Number(n.dnevnica_eur || 0);
                    const rsd = Number(n.dnevnica_rsd || 0);
                    row.getCell(dnCol.tura).value = n.br_naloga || '';
                    row.getCell(dnCol.eur).value  = eur || '';
                    row.getCell(dnCol.rsd).value  = rsd || '';
                    if (eur) row.getCell(dnCol.eur).numFmt = '#,##0.00 "€"';
                    if (rsd) row.getCell(dnCol.rsd).numFmt = domesticIsEur ? '#,##0.00 "€"' : '#,##0.00 "Din."';
                    [dnCol.tura, dnCol.eur, dnCol.rsd].forEach(c => { row.getCell(c).border = bThin; });
                    dnSumEur += eur;
                    dnSumRsd += rsd;
                });

                const dnTotalRow = ws.getRow(mainHdr.number + 1 + nalozi_xl.length);
                dnTotalRow.getCell(dnCol.tura).value  = 'UKUPNO';
                dnTotalRow.getCell(dnCol.eur).value   = dnSumEur;
                dnTotalRow.getCell(dnCol.eur).numFmt  = '#,##0.00 "€"';
                dnTotalRow.getCell(dnCol.rsd).value   = dnSumRsd;
                dnTotalRow.getCell(dnCol.rsd).numFmt  = domesticIsEur ? '#,##0.00 "€"' : '#,##0.00 "Din."';
                dnTotalRow.getCell(dnCol.grand).value  = domesticIsEur ? (dnSumEur + dnSumRsd) : (dnSumEur + (dnSumRsd / zagKurs_h));
                dnTotalRow.getCell(dnCol.grand).numFmt = '#,##0.00 "€"';
                dnTotalRow.font = { bold: true };
                [dnCol.tura, dnCol.eur, dnCol.rsd, dnCol.grand].forEach(c => {
                    dnTotalRow.getCell(c).fill   = fillYel;
                    dnTotalRow.getCell(c).border = bMed;
                });

                /* ===== TABELA 2: PREGLED AKONTACIJA ===== */
                ws.addRow([]);
                const ak2TitleRow = ws.addRow(['PREGLED AKONTACIJA']);
                ak2TitleRow.getCell(1).font = { bold: true, size: 12 };
                ws.mergeCells(ak2TitleRow.number, 1, ak2TitleRow.number, 12);

                /* header red 1 — grupni naslovi */
                const ah1 = ws.addRow(['DATUM', 'BR NALOGA', 'ZADUŽENJE', '', 'YES MONEY', 'RAZDUŽENJE', '', 'TROŠAK', '', 'OSTAO DUŽAN', '', '']);
                ws.mergeCells(ah1.number, 3, ah1.number, 4);   // ZADUŽENJE
                ws.mergeCells(ah1.number, 6, ah1.number, 7);   // RAZDUŽENJE
                ws.mergeCells(ah1.number, 8, ah1.number, 9);   // TROŠAK
                ws.mergeCells(ah1.number, 10, ah1.number, 11); // OSTAO DUŽAN
                ah1.font = { bold: true };
                ah1.eachCell(cell => { cell.fill = fillBlue; cell.border = bMed; cell.alignment = { horizontal: 'center', vertical: 'middle' }; });

                /* header red 2 — pod-naslovi */
                const ah2 = ws.addRow(['', '', '€', 'RSD', '', '€', 'RSD', '€', 'RSD', '€', 'RSD', '']);
                /* vertikalni merge za DATUM, BR NALOGA i YES MONEY */
                ws.mergeCells(ah1.number, 1, ah2.number, 1);
                ws.mergeCells(ah1.number, 2, ah2.number, 2);
                ws.mergeCells(ah1.number, 5, ah2.number, 5);
                ws.mergeCells(ah1.number, 12, ah2.number, 12);
                ah2.font = { bold: true };
                ah2.eachCell(cell => { cell.fill = fillBlue; cell.border = bMed; cell.alignment = { horizontal: 'center', vertical: 'middle' }; });

                /* data redovi */
                let sumZadEur=0, sumZadRsd=0, sumRazdEur=0, sumRazdRsd=0, sumTrosEur=0, sumOstEur2=0, sumOstRsd2=0;

                nalozi_xl.forEach(n => {
                    const zadEur  = Number(n.akontacija_eur||0);
                    const zadRsd  = Number(n.akontacija_rsd||0);
                    const razdEur = Number(n.razduzenje_eur||0);
                    const razdRsd = Number(n.razduzenje_rsd||0);
                    const trosEur = Number(n.trosak_gotovina_eur||0);
                    const ostEur  = zadEur - razdEur - trosEur;
                    const ostRsd  = zadRsd - razdRsd;
                    const datum   = n.dat_od === n.dat_do
                        ? (n.dat_od||'')
                        : `${n.dat_od||''} + ${n.dat_do||''}`;

                    const dr = ws.addRow([
                        datum, n.br_naloga,
                        zadEur  || '', zadRsd  || '',
                        '',
                        razdEur || '', razdRsd || '',
                        trosEur || '', '',
                        ostEur, ostRsd || '',
                        '',
                    ]);
                    const fmtE = '#,##0.00 "€"';
                    const fmtR = '#,##0.00 "RSD"';
                    [[3,fmtE],[4,fmtR],[6,fmtE],[7,fmtR],[8,fmtE],[10,fmtE],[11,fmtR]].forEach(([c,fmt]) => {
                        if (dr.getCell(c).value !== '') dr.getCell(c).numFmt = fmt;
                        dr.getCell(c).alignment = { horizontal: 'right' };
                    });
                    dr.eachCell(cell => { cell.border = bThin; });

                    sumZadEur  += zadEur;  sumZadRsd  += zadRsd;
                    sumRazdEur += razdEur; sumRazdRsd += razdRsd;
                    sumTrosEur += trosEur;
                    sumOstEur2 += ostEur;  sumOstRsd2 += ostRsd;
                });

                /* ukupno red */
                const ak2Tot = ws.addRow([
                    'UKUPNO', '',
                    sumZadEur, sumZadRsd, '',
                    sumRazdEur, sumRazdRsd,
                    sumTrosEur, '',
                    sumOstEur2, sumOstRsd2,
                    '',
                ]);
                ak2Tot.font = { bold: true };
                [[3,'#,##0.00 "€"'],[4,'#,##0.00 "RSD"'],[6,'#,##0.00 "€"'],[7,'#,##0.00 "RSD"'],
                 [8,'#,##0.00 "€"'],[10,'#,##0.00 "€"'],[11,'#,##0.00 "RSD"']].forEach(([c,fmt]) => {
                    ak2Tot.getCell(c).numFmt = fmt;
                    ak2Tot.getCell(c).alignment = { horizontal: 'right' };
                });
                ak2Tot.eachCell(cell => { cell.fill = fillYel; cell.border = bMed; });

                /* grand total: ostao dužan EUR + RSD→EUR, sve u EUR (kolona 12) */
                const grandEur = sumOstEur2 + (sumOstRsd2 / zagKurs_h);
                const ak2Grand = ws.addRow(['', '', '', '', '', '', '', '', '', '', '', grandEur]);
                ak2Grand.getCell(10).value = 'Ukupno dužan (EUR + RSD→EUR):';
                ws.mergeCells(ak2Grand.number, 10, ak2Grand.number, 11);
                ak2Grand.getCell(12).numFmt = '#,##0.00 "€"';
                ak2Grand.getCell(12).font = { bold: true };
                ak2Grand.getCell(12).fill = fillYel;
                ak2Grand.getCell(12).border = bMed;
                ak2Grand.getCell(10).font = { bold: true };

                /* ===== TABELA 3: DANI RADA ===== */
                ws.addRow([]);
                const calTitleRow = ws.addRow(['DANI RADA']);
                calTitleRow.getCell(1).font = { bold: true, size: 12 };
                ws.mergeCells(calTitleRow.number, 1, calTitleRow.number, 12);

                const fillWeekend  = { type:'pattern', pattern:'solid', fgColor:{ argb:'FFD9D9D9' } };
                const fillGreenDay = { type:'pattern', pattern:'solid', fgColor:{ argb:'FFD4EDDA' } };
                const fillEmpty    = { type:'pattern', pattern:'solid', fgColor:{ argb:'FFF5F5F5' } };
                const bMedDnevnice = { top: med, left: thin, bottom: med, right: thin };
                const COLS_CAL = 7;
                const isoDow = dStr => { const d = new Date(dStr).getDay(); return d === 0 ? 7 : d; };

                /* ceo period od dnevnice_od do dnevnice_do — dani bez aktivnosti = _empty slot.
                   SP vraća dnevnice_od/do kao FORMAT 'dd.MM.yyyy.' ("01.05.2026.") — parsiramo ručno,
                   jer new Date("01.05.2026.") = Invalid Date (truthy, ali NaN u poređenju). */
                const parseFmtDatum = (s) => {
                    if (!s) return null;
                    const p = String(s).replace(/\.$/, '').split('.');
                    if (p.length < 3) return null;
                    const d = new Date(Number(p[2]), Number(p[1]) - 1, Number(p[0])); // lokalni midnight
                    return isNaN(d) ? null : d;
                };

                const daniMap_xl = {};
                /* d.datum = raw DATE iz mssql → JSON "2026-05-01T00:00:00.000Z" → slice(0,10) = "2026-05-01" */
                dani_xl.forEach(d => { const k = (d.datum || '').slice(0,10); if (k) daniMap_xl[k] = d; });

                const calStart = parseFmtDatum(h.dnevnice_od);
                const calEnd   = parseFmtDatum(h.dnevnice_do);
                const calWeeks = [];
                if (calStart && calEnd) {
                    let week = new Array(isoDow(calStart) - 1).fill(null);
                    const cur = new Date(calStart);
                    while (cur <= calEnd) {
                        const key = `${cur.getFullYear()}-${String(cur.getMonth()+1).padStart(2,'0')}-${String(cur.getDate()).padStart(2,'0')}`;
                        const dp  = `${String(cur.getDate()).padStart(2,'0')}.${String(cur.getMonth()+1).padStart(2,'0')}.`;
                        week.push(daniMap_xl[key] || { _empty: true, datum: key, datumPrikaz: dp, koeficijent: 0, tip_dan: null });
                        if (week.length === COLS_CAL) { calWeeks.push(week); week = []; }
                        cur.setDate(cur.getDate() + 1);
                    }
                    if (week.length) { while (week.length < COLS_CAL) week.push(null); calWeeks.push(week); }
                } else if (dani_xl.length) {
                    // fallback: samo aktivni dani ako nema dnevnice perioda u headeru
                    let week = new Array(isoDow(dani_xl[0].datum) - 1).fill(null);
                    dani_xl.forEach(d => {
                        week.push(d);
                        if (week.length === COLS_CAL) { calWeeks.push(week); week = []; }
                    });
                    if (week.length) { while (week.length < COLS_CAL) week.push(null); calWeeks.push(week); }
                }

                calWeeks.forEach((week, wi) => {
                    if (wi > 0) ws.addRow([]);
                    const dRw = ws.addRow(week.map(x => x?.datumPrikaz?.slice(0,5) || ''));
                    const kRw = ws.addRow(week.map(x => {
                        if (!x || x._empty) return '';
                        const kv = Number(x.koeficijent || 0);
                        return x.tip_dan === 'G' || x.tip_dan === 'B' || x.tip_dan === 'R' ? `${kv.toFixed(1)} ${x.tip_dan}` : kv;
                    }));
                    week.forEach((dayData, ci) => {
                        const col = ci + 1;
                        const dc = dRw.getCell(col);
                        const kc = kRw.getCell(col);
                        if (!dayData) { dc.border = bMed; kc.border = bMedDnevnice; return; }

                        const dow = new Date(dayData.datum).getDay();
                        const isWknd = dow === 0 || dow === 6;
                        const isEmpty = !!dayData._empty;
                        const kv = Number(dayData.koeficijent || 0);
                        const isAbsence = dayData.tip_dan === 'G' || dayData.tip_dan === 'B' || dayData.tip_dan === 'R';

                        dc.font = { bold: !isEmpty, size: 10, color: { argb: isEmpty ? 'FFB0B0B0' : 'FF000000' } };
                        dc.alignment = { horizontal: 'center' }; dc.border = bMed;
                        if (isEmpty || isWknd) dc.fill = isWknd ? fillWeekend : fillEmpty;

                        kc.alignment = { horizontal: 'center' }; kc.border = bMedDnevnice;
                        if (isEmpty) {
                            kc.fill = isWknd ? fillWeekend : fillEmpty;
                        } else {
                            kc.font = { bold: true, size: 9, color: { argb: kv >= 0.5 ? 'FFFF0000' : 'FF000000' } };
                            if (!isAbsence) kc.numFmt = '0.0';
                            if (isWknd) kc.fill = fillWeekend;
                            else if (kv >= 1.0) kc.fill = fillGreenDay;
                            else if (kv >= 0.5) kc.fill = fillYel;
                        }
                    });
                });
                const totalKoef2 = dani_xl.reduce((s,d) => s + Number(d.koeficijent||0), 0);
                const calTotRw = ws.addRow([`Ukupno dana: ${totalKoef2.toFixed(1)}`]);
                calTotRw.font = { bold: true };
                ws.mergeCells(calTotRw.number, 1, calTotRw.number, 12);
            }

            wb.views = [{ activeTab: wb.worksheets.length - 1 }];

            const zapNazivFile = zaposleniDB.find(z => z.value === genZap)?.label || '';
            const buffer = await wb.xlsx.writeBuffer();
            const fileName = `Obracun plate - ${zapNazivFile} - ${company?.companyName||''}.xlsx`;
            saveAs(new Blob([buffer], { type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), fileName);
            showToast('success', 'Sumarni Excel je preuzet!');
        } catch (e) {
            showToast('error', 'Greška pri eksportu: ' + (e?.message || ''));
        }
    };

    /* DataTable header — PREGLED */
    const pregledHeader = (
        <div className="export-buttons fakture-stavke-header">
            <Tooltip target=".export-buttons>button" position="bottom" />
            <div className="fakture-stavke-radnje">
                <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportPregledExcel} data-pr-tooltip="XLS" />
                {selectedPregledId && (
                    <Button type="button" icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFromPregled} data-pr-tooltip="Obriši" />
                )}
            </div>
            <input type="search" placeholder={t('common.search')} className="p-inputtext p-component"
                onInput={e => setPregledGlobalFilter(e.target.value)} />
        </div>
    );

    /* DataTable header — Nalozi */
    const naloziHeader = (
        <div className="export-buttons-nalozi fakture-stavke-header">
            <Tooltip target=".export-buttons-nalozi>button" position="bottom" />
            <div className="fakture-stavke-radnje">
                {selectedNalogId && !isLocked && (
                    <>
                        <Button type="button" label={t('finansije.sacuvajNalog')} icon="pi pi-save"
                            severity="success" size="small" onClick={handleSaveNalog}
                            data-pr-tooltip="Sačuvaj izmenu" />
                        <Button type="button" icon="pi pi-trash" severity="danger" size="small" rounded
                            onClick={() => handleRemoveNalog(selectedNalogId)}
                            data-pr-tooltip="Ukloni turu iz obračuna" />
                    </>
                )}
                {!isLocked && (
                    <Button type="button"
                        icon={showAddTrip ? 'pi pi-times' : 'pi pi-plus'}
                        severity={showAddTrip ? 'secondary' : 'info'}
                        size="small" rounded
                        onClick={() => {
                            if (!showAddTrip) loadAvailableTrips();
                            setShowAddTrip(p => !p);
                            setSelectedAddTrip(null);
                        }}
                        data-pr-tooltip={showAddTrip ? 'Zatvori' : 'Dodaj turu'} />
                )}
                <Button type="button" label={t('finansije.sumarniExcel')} icon="pi pi-file-excel"
                    severity="success" size="small" onClick={exportSviMeseci}
                    disabled={!genZap}
                    data-pr-tooltip="Svi meseci za izabranog vozača" />
            </div>
            <input type="search" placeholder={t('finansije.pretragaNaloga')} className="p-inputtext p-component"
                onInput={e => setNaloziGlobalFilter(e.target.value)} style={{ width: 180 }} />
        </div>
    );

    const koefBg    = (k) => k >= 1.0 ? '#d4edda' : k >= 0.5 ? '#fff3cd' : '#f8f9fa';
    const koefColor = (k) => k >= 1.0 ? '#155724' : k >= 0.5 ? '#856404' : '#6c757d';

    const activeClass = 'activeButton';

    return (
        <div style={{ marginTop: '1%' }}>
            <Toast ref={toast} />
            <ConfirmDialog />

            {/* Tab nav */}
            <Button id={changeView === 1 ? activeClass : undefined}
                label={t('common.unos')} className="mt-3 zaposleniShift"
                style={{ fontSize:'smaller' }}
                onClick={() => { resetUnos(); setChangeView(1); }} />
            <Button id={changeView === 2 ? activeClass : undefined}
                label={t('fakture.pregled')} className="mt-3 zaposleniShift"
                style={{ fontSize:'smaller' }} onClick={() => { resetUnos(); setChangeView(2); }} />
            <Button id={changeView === 3 ? activeClass : undefined}
                label={t('subnav.izvestaji')} className="mt-3 zaposleniShift"
                style={{ fontSize:'smaller' }} onClick={() => { resetUnos(); setChangeView(3); }} />

            {/* ====================== UNOS ====================== */}
            {changeView === 1 && (
                <div className="col-12">

                    {/* Sub-tab navigacija — van grid kontejnera */}
                    {obracunId && (
                        <div style={{ display:'flex', marginBottom:'1%', marginTop:'1%' }}>
                            <Button label={t('finansije.noviUnos')} icon="pi pi-plus-circle"
                                severity="secondary"
                                className="zaposleniShift marginLeftNone" style={{ fontSize:'smaller' }}
                                onClick={resetUnos} />
                            <Button label={t('finansije.zaglavlje')} icon="pi pi-sliders-h"
                                id={unosTab === 1 ? 'activeButton' : undefined}
                                className="zaposleniShift" style={{ fontSize:'smaller', marginLeft: 0 }}
                                onClick={() => setUnosTab(1)} />
                            <Button label={`ISPLATE${isplate.length > 0 ? ` (${isplate.length})` : ''}`} icon="pi pi-wallet"
                                id={unosTab === 2 ? 'activeButton' : undefined}
                                className="zaposleniShift" style={{ fontSize:'smaller' }}
                                onClick={() => setUnosTab(2)} />
                            <Button label={`BONUSI${bonusi.length > 0 ? ` (${bonusi.length})` : ''}`} icon="pi pi-star"
                                id={unosTab === 3 ? 'activeButton' : undefined}
                                className="zaposleniShift" style={{ fontSize:'smaller' }}
                                onClick={() => setUnosTab(3)} />
                            <Button label={`DANI${dani.length > 0 ? ` (${fmt(totalDaniKoef)})` : ''}`} icon="pi pi-calendar"
                                id={unosTab === 4 ? 'activeButton' : undefined}
                                className="zaposleniShift" style={{ fontSize:'smaller' }}
                                onClick={() => setUnosTab(4)} />
                            <i className={isLocked ? 'pi pi-lock' : 'pi pi-lock-open'}
                                title={isLocked ? 'ZATVOREN' : 'AKTIVAN'}
                                style={{ alignSelf:'center', marginLeft:6, fontSize:28, color: isLocked ? '#dc3545' : '#28a745' }} />
                        </div>
                    )}

                    <div className="blagajnaDashboard dnevniceDashboard">

                        {/* Generator + akcije */}
                        <Card style={{minWidth: 'max-content'}}>
                            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>

                                <div style={{ display:'flex', flexWrap:'wrap', gap:10, alignItems:'flex-end' }}>
                                    <div>
                                        <label style={{ display:'block', marginBottom:3 }}>{t('finansije.zaposleni')}</label>
                                        <Dropdown value={genZap} options={zaposleniDB}
                                            onChange={e => setGenZap(e.value)}
                                            placeholder={t('ture.phVozaca')} style={{ width:220 }} filter showClear />
                                    </div>
                                    <div>
                                        <label style={{ display:'block', marginBottom:3 }}>{t('finansije.mesec')}</label>
                                        <Dropdown value={genMesec} options={MESECI}
                                            onChange={e => setGenMesec(e.value)} style={{ width:140 }} />
                                    </div>
                                    <div>
                                        <label style={{ display:'block', marginBottom:3 }}>{t('finansije.godina')}</label>
                                        <InputNumber value={genGodina} onValueChange={e => setGenGodina(e.value)}
                                            mode="decimal" useGrouping={false} style={{ width:90 }} />
                                    </div>
                                </div>

                                <div style={{ display:'flex', flexWrap:'wrap', gap:10, alignItems:'flex-end' }}>
                                    <div style={{ minHeight: 'stretch',display:'flex', alignItems:'center'}}> 
                                        <span style={{ fontSize:20, fontWeight:600, color:'#495057', minWidth:100}}>Ture:</span>
                                    </div>
                                    <div>
                                        <Calendar value={genDatOd} onChange={e => setGenDatOd(e.value)}
                                            dateFormat="dd.mm.yy" style={{ width:120 }} />
                                    </div>
                                    <div>
                                        <Calendar value={genDatDo} onChange={e => setGenDatDo(e.value)}
                                            dateFormat="dd.mm.yy" style={{ width:120 }} />
                                    </div>
                                </div>

                                <div style={{ display:'flex', flexWrap:'wrap', gap:10, alignItems:'flex-end' }}>
                                    <div style={{ minHeight: 'stretch',display:'flex', alignItems:'center'}}> 
                                        <span style={{ fontSize:20, fontWeight:600, color:'#495057', minWidth:100}}>Dnevnice:</span>
                                    </div>
                                    <div>
                                        <Calendar value={genDnevniceOd} onChange={e => setGenDnevniceOd(e.value)}
                                            dateFormat="dd.mm.yy" style={{ width:120 }} />
                                    </div>
                                    <div>
                                        <Calendar value={genDnevniceDo} onChange={e => setGenDnevniceDo(e.value)}
                                            dateFormat="dd.mm.yy" style={{ width:120 }} />
                                    </div>
                                </div>

                                <div style={{ display:'flex', flexWrap:'wrap', gap:10, alignItems:'center' }}>
                                    <Button label={t('finansije.generisi')} icon="pi pi-cog" severity="primary"
                                        loading={generating} disabled={!!obracunId}
                                        onClick={handleGenerate} />


                                {obracunId && (
                                    <div style={{ marginLeft:'auto', display:'flex', gap:8, alignItems:'center' }}>
                                        {isLocked && (
                                            <>
                                                <span style={{ background:'#721c24', color:'#fff', padding:'3px 10px', borderRadius:4, fontSize:12, fontWeight:600 }}>
                                                    ZATVOREN
                                                </span>
                                                {canUnlock && (
                                                    <Button label={t('finansije.otkljucaj')} icon="pi pi-unlock" severity="info" size="small" onClick={handleUnlock} />
                                                )}
                                            </>
                                        )}
                                        {!isLocked && (
                                            <>
                                                <Button label={t('finansije.sacuvajZaglavlje')} icon="pi pi-save" severity="success" size="small" onClick={handleSaveHeader} />
                                                <Button label={t('common.close')} icon="pi pi-lock" severity="warning" size="small" onClick={handleClose} />
                                            </>
                                        )}
                                        <Button label={t('common.delete')} icon="pi pi-trash" severity="danger" size="small" onClick={handleDelete} disabled={isLocked} />
                                    </div>
                                )}
                                </div>


                            </div>
                        </Card>

                        {/* Total bar + ZAGLAVLJE u istoj Card */}
                        {obracunId && (
                            <Card style={{ padding:0 }}>
                                <Tooltip target=".zarada-bruto-tooltip" position="bottom" />
                                <div style={{ display:'flex', gap:0, border:'2px solid #343a40', borderRadius:6, overflow:'hidden' }}>
                                    {[
                                        { label:'ZARADA',    value: zarada,  bg:'#d4edda', color:'#155724' },
                                        { label:'ODBITCI',   value: odbitci, bg:'#f8d7da', color:'#721c24' },
                                        { label:'DUG',       value: runningDug, bg:'#fff3cd', color:'#856404' },
                                        { label:'SALDO',     value: saldo,   bg: Math.round(saldo*100)/100 >= 0 ? '#cce5ff' : '#f8d7da', color: Math.round(saldo*100)/100 >= 0 ? '#004085' : '#721c24' },
                                        { label:'MINIMALAC', value: toEurField(formHeader.minimalac, formHeader.minimalac_valuta), bg:'#f8f9fa', color:'#495057' },
                                    ].map(({ label, value, bg, color }, i, arr) => (
                                        <div key={label} style={{
                                            flex:1, background:bg, padding:'10px 16px',
                                            borderRight: i < arr.length - 1 ? '2px solid #343a40' : 'none',
                                        }}>
                                            <div style={{ fontSize:11, color, fontWeight:600 }}>
                                                {label}
                                                {label === 'ZARADA' && !!formHeader.dnevnica_rus_fix && (
                                                    <span style={{ marginLeft:6, fontWeight:700 }}>
                                                        (sadrži RUS turu — fix po turi{formHeader.dnevnica_rus_dani ? `, ${formHeader.dnevnica_rus_dani} dana` : ''})
                                                    </span>
                                                )}
                                            </div>
                                            <div style={{ fontSize:20, fontWeight:700, color }}
                                                className={label === 'ZARADA' ? 'zarada-bruto-tooltip' : ''}
                                                data-pr-tooltip={label === 'ZARADA' ? `Bruto (KM+dnevnice+bonusi): ${fmt(zaradaBruto)} € — Minimalac: ${fmt(minimalacEur)} €` : undefined}>
                                                {fmt(value)} {label.includes('RSD') ? 'RSD' : '€'}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* ZAGLAVLJE ispod total bara, u istoj Card */}
                                {unosTab === 1 && (
                                    <div style={{ marginTop:14, paddingTop:12, borderTop:'1px solid #dee2e6' }}>
                                        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                                            <div style={{ display:'flex', gap:10 }}>
                                                <div style={{ flex:2 }}>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('finansije.obradio')}</label>
                                                    <InputText value={obradioNaziv}
                                                        disabled
                                                        style={{ width:'100%' }} />
                                                </div>
                                                <div style={{ flex:1 }}>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('finansije.prethodniSaldo')}</label>
                                                    <InputNumber value={formHeader.saldo_prethodni}
                                                        mode="decimal" minFractionDigits={2} maxFractionDigits={2}
                                                        disabled
                                                        style={{ width:'100%' }} inputStyle={{ width:'100%', textAlign:'right' }} />
                                                </div>
                                                <div style={{ flex:1 }}>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('finansije.kursEUR')}</label>
                                                    <InputNumber value={formHeader.kurs}
                                                        onValueChange={e => setFormHeader(p => ({ ...p, kurs: e.value }))}
                                                        mode="decimal" minFractionDigits={4} maxFractionDigits={4}
                                                        disabled={isLocked}
                                                        style={{ width:'100%' }} inputStyle={{ width:'100%', textAlign:'right' }} />
                                                </div>
                                            </div>
                                            {zaglavljeStavke.length === 0 && (
                                                <div style={{ color:'#6c757d', fontSize:12, padding:'8px 0' }}>
                                                    Nema konfigurisanih stavki zaglavlja. Dodajte ih u Administracija → Obračun ture → Zaglavlje obr. plate.
                                                </div>
                                            )}
                                            {zaglavljeStavke.map(s => (
                                                <div key={s.value} style={{ width:'100%', border:'1px solid #adb5bd', borderRadius:6, padding:8 }}>
                                                    <label style={{ display:'block', marginBottom:2 }}>
                                                        {s.label}
                                                        <span style={{ marginLeft:6, fontSize:10, color: (idTipDodatak !== null ? s.TipTransakcije === idTipDodatak : false) ? '#198754' : '#dc3545', fontWeight:600 }}>
                                                            {(idTipDodatak !== null ? s.TipTransakcije === idTipDodatak : false) ? '▲ Dodatak' : '▼ Odbitak'}
                                                        </span>
                                                    </label>
                                                    <div style={{ display:'flex', gap:10 }}>
                                                        <div style={{ flex:'0 0 140px' }}>
                                                            <Dropdown
                                                                value={zaglavljeVrednosti[s.value]?.valuta_id ?? s.valuta_id}
                                                                options={zaglavljeValuteDB.length ? zaglavljeValuteDB : EUR_RSD_OPTIONS}
                                                                optionLabel="label" optionValue="value"
                                                                onChange={e => setZaglavljeVrednosti(prev => ({ ...prev, [s.value]: { ...prev[s.value], valuta_id: e.value } }))}
                                                                disabled={isLocked}
                                                                style={{ width:'100%' }} />
                                                        </div>
                                                        <div style={{ flex:1 }}>
                                                            <InputNumber
                                                                value={zaglavljeVrednosti[s.value]?.iznos ?? 0}
                                                                onValueChange={e => setZaglavljeVrednosti(prev => ({ ...prev, [s.value]: { ...prev[s.value], iznos: e.value } }))}
                                                                mode="decimal" minFractionDigits={2} maxFractionDigits={2}
                                                                disabled={isLocked}
                                                                style={{ width:'100%' }} inputStyle={{ width:'100%', textAlign:'right' }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div>
                                                <label style={{ display:'block', marginBottom:2 }}>{t('nova.napomena')}</label>
                                                <InputText value={formHeader.napomena}
                                                    onChange={e => setFormHeader(p => ({ ...p, napomena: e.target.value }))}
                                                    disabled={isLocked} style={{ width:'100%' }} />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* ISPLATE */}
                                {unosTab === 2 && (
                                    <div style={{ marginTop:16, borderTop:'1px solid #dee2e6', paddingTop:12 }}>
                                        <div style={{ fontWeight:600, marginBottom:8, fontSize:13 }}>Isplate / korekcije</div>
                                        {!isLocked && (
                                            <div style={{ display:'flex', flexWrap:'wrap', gap:8, alignItems:'flex-end', marginBottom:10 }}>
                                                <div>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('nova.datum')}</label>
                                                    <Calendar value={formIsplata.datum_isplate}
                                                        onChange={e => setFormIsplata(p => ({ ...p, datum_isplate: e.value }))}
                                                        invalid={invalidIsplata(formIsplata.datum_isplate)}
                                                        dateFormat="dd.mm.yy" style={{ width:130 }} />
                                                </div>
                                                <div>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('nova.tip')}</label>
                                                    <Dropdown value={formIsplata.tip}
                                                        options={tipIsplateDB}
                                                        optionLabel="label" optionValue="value"
                                                        onChange={e => setFormIsplata(p => ({ ...p, tip: e.value }))}
                                                        style={{ width:160 }} />
                                                </div>
                                                <div>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('nova.opis')}</label>
                                                    <InputText value={formIsplata.opis_isplate}
                                                        onChange={e => setFormIsplata(p => ({ ...p, opis_isplate: e.target.value }))}
                                                        style={{ width:200 }} />
                                                </div>
                                                <div>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('ture.iznosEur')}</label>
                                                    <InputNumber value={formIsplata.iznos_eur_isp}
                                                        onValueChange={e => setFormIsplata(p => ({ ...p, iznos_eur_isp: e.value }))}
                                                        mode="decimal" minFractionDigits={2} maxFractionDigits={2}
                                                        inputStyle={{ width:100, textAlign:'right' }} />
                                                </div>
                                                <div>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('finansije.iznosRSD')}</label>
                                                    <InputNumber value={formIsplata.iznos_rsd_isp}
                                                        onValueChange={e => setFormIsplata(p => ({ ...p, iznos_rsd_isp: e.value }))}
                                                        mode="decimal" minFractionDigits={2} maxFractionDigits={2}
                                                        inputStyle={{ width:100, textAlign:'right' }} />
                                                </div>
                                                <Button label={selectedIsplataId ? 'Sačuvaj' : 'Dodaj'}
                                                    icon={selectedIsplataId ? 'pi pi-check' : 'pi pi-plus'} size="small"
                                                    severity="info" onClick={handleAddIsplata} />
                                                {selectedIsplataId && (
                                                    <Button label={t('common.cancel')} icon="pi pi-times" size="small"
                                                        severity="secondary" className="p-button-text"
                                                        onClick={handleCancelEditIsplata} />
                                                )}
                                            </div>
                                        )}
                                        {isplate.length > 0 ? (
                                            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
                                                <thead>
                                                    <tr style={{ background:'#343a40' }}>
                                                        {['Datum','Tip','Opis','EUR','RSD',!isLocked ? ' ' : null].filter(Boolean).map((h, idx) => (
                                                            <th key={idx} style={{ padding:'4px 8px', border:'1px solid #dee2e6', background:'#343a40', textAlign:'center', color:'#fff' }}>{h}</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isplate.map(i => (
                                                        <tr key={i.id}>
                                                            <td style={{ padding:'3px 8px', border:'1px solid #dee2e6', textAlign:'center' }}>{i.datumPrikaz}</td>
                                                            <td style={{ padding:'3px 8px', border:'1px solid #dee2e6', textAlign:'center' }}>
                                                                <span style={{ fontSize:11, fontWeight:600, color: (i.tipNaziv === 'Odbitak' || i.tipNaziv === 'Vraćanje duga' || i.tipNaziv === 'Pozajmica') ? '#721c24' : '#155724' }}>
                                                                    {i.tipNaziv || 'Isplata (plata)'}
                                                                </span>
                                                            </td>
                                                            <td style={{ padding:'3px 8px', border:'1px solid #dee2e6', textAlign:'center' }}>{i.opis}</td>
                                                            <td style={{ padding:'3px 8px', border:'1px solid #dee2e6', textAlign:'center' }}>{fmt(i.iznos_eur)}</td>
                                                            <td style={{ padding:'3px 8px', border:'1px solid #dee2e6', textAlign:'center' }}>{fmt(i.iznos_rsd)}</td>
                                                            {!isLocked && (
                                                                <td style={{ padding:'3px 8px', border:'1px solid #dee2e6', textAlign:'center', whiteSpace:'nowrap' }}>
                                                                    <Button icon="pi pi-pencil" size="small" severity="info"
                                                                        className="p-button-text"
                                                                        onClick={() => handleEditIsplata(i)} />
                                                                    <Button icon="pi pi-times" size="small" severity="danger"
                                                                        className="p-button-text"
                                                                        onClick={() => handleDeleteIsplata(i.id)} />
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <p style={{ fontSize:12, color:'#6c757d', margin:0 }}>Nema isplata.</p>
                                        )}
                                    </div>
                                )}

                                {/* BONUSI */}
                                {unosTab === 3 && (
                                    <div style={{ marginTop:16, borderTop:'1px solid #dee2e6', paddingTop:12 }}>
                                        <div style={{ fontWeight:600, marginBottom:10, fontSize:13 }}>Dodatni bonusi</div>
                                        {!isLocked && (
                                            <div style={{ display:'flex', flexWrap:'wrap', gap:8, alignItems:'flex-end', marginBottom:12 }}>
                                                <div>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('nova.tura')}</label>
                                                    <Dropdown
                                                        value={formBonus.id_obracun_nalog}
                                                        options={nalozi.map(n => ({ value: n.id, label: `${n.br_naloga} (${n.dat_od} - ${n.dat_do})` }))}
                                                        invalid={invalidBonus(formBonus.id_obracun_nalog)}
                                                        onChange={e => {
                                                            setFormBonus(p => ({ ...p, id_obracun_nalog: e.value, id_sifarnik: null, opis_bonus: '', iznos_eur_bon: 0 }));
                                                            fetchSifarnikForNalog(e.value);
                                                        }}
                                                        placeholder={t('finansije.izaberiTuru')}
                                                        showClear style={{ width:240 }} filter />
                                                </div>
                                                <div>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('ture.vrstaBonusa')}</label>
                                                    <Dropdown
                                                        value={formBonus.id_sifarnik}
                                                        options={filteredBonusiSifarnikPlate}
                                                        disabled={!formBonus.id_obracun_nalog}
                                                        onChange={e => {
                                                            const izabran = filteredBonusiSifarnikPlate.find(b => b.value === e.value);
                                                            setFormBonus(p => ({
                                                                ...p,
                                                                id_sifarnik: e.value,
                                                                opis_bonus: izabran ? izabran.label : p.opis_bonus,
                                                                iznos_eur_bon: izabran ? Number(izabran.Iznos || 0) : p.iznos_eur_bon,
                                                            }));
                                                        }}
                                                        placeholder={formBonus.id_obracun_nalog ? 'Izaberi vrstu (opciono)' : 'Najpre izaberite turu'}
                                                        showClear style={{ width:240 }} filter />
                                                </div>
                                                <div>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('nova.opis')}</label>
                                                    <InputText
                                                        value={formBonus.opis_bonus}
                                                        invalid={!formBonus.id_sifarnik && invalidBonus(formBonus.opis_bonus)}
                                                        onChange={e => setFormBonus(p => ({ ...p, opis_bonus: e.target.value }))}
                                                        placeholder={t('ture.opisBonusa')}
                                                        style={{ width:220 }} />
                                                </div>
                                                <div>
                                                    <label style={{ display:'block', marginBottom:2 }}>{t('ture.iznosEur')}</label>
                                                    <InputNumber
                                                        value={formBonus.iznos_eur_bon}
                                                        onValueChange={e => setFormBonus(p => ({ ...p, iznos_eur_bon: e.value }))}
                                                        mode="decimal" minFractionDigits={2} maxFractionDigits={2}
                                                        inputStyle={{ width:100, textAlign:'right' }} />
                                                </div>
                                                <div style={{ display:'flex', gap:6, alignItems:'flex-end' }}>
                                                {selectedBonusId ? (
                                                    <>
                                                        <Button label={t('ture.azuriraj')} icon="pi pi-check"
                                                            severity="warning" onClick={handleUpdateBonus} />
                                                        <Button label={t('nova.odustani')} icon="pi pi-times"
                                                            severity="secondary" onClick={() => {
                                                                setSelectedBonusId(null);
                                                                setFormBonus({ id_sifarnik: null, id_obracun_nalog: null, opis_bonus: '', iznos_eur_bon: 0 });
                                                                setFilteredBonusiSifarnikPlate([]);
                                                                setBonusSubmitted(false);
                                                            }} />
                                                    </>
                                                ) : (
                                                    <Button label={t('common.add')} icon="pi pi-plus"
                                                        severity="success" onClick={handleAddBonus} />
                                                )}
                                                </div>
                                            </div>
                                        )}
                                        {bonusi.length > 0 ? (
                                            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
                                                <thead>
                                                    <tr style={{ background:'#343a40' }}>
                                                        {['Opis', 'Iznos €', !isLocked ? ' ' : null].filter(Boolean).map((h, idx) => (
                                                            <th key={idx} style={{ padding:'4px 8px', border:'1px solid #dee2e6', background:'#343a40', textAlign:'center', color:'#fff' }}>{h}</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bonusi.map(b => (
                                                        <tr key={b.id}
                                                            style={{ background: b.id === selectedBonusId ? '#fff3cd' : 'transparent' }}>
                                                            <td style={{ padding:'3px 8px', border:'1px solid #dee2e6' }}>
                                                                {b.opis}
                                                                {b.id_sifarnik && <span style={{ marginLeft:6, fontSize:10, color:'#6c757d', background:'#e9ecef', padding:'1px 5px', borderRadius:3 }}>sifarnik</span>}
                                                                {b.br_naloga && <span style={{ marginLeft:6, fontSize:10, color:'#155724', background:'#d4edda', padding:'1px 5px', borderRadius:3 }}>{b.br_naloga}</span>}
                                                            </td>
                                                            <td style={{ padding:'3px 8px', border:'1px solid #dee2e6', textAlign:'right', fontWeight:600, color:'#155724' }}>{fmt(b.iznos_eur)}</td>
                                                            {!isLocked && (
                                                                <td style={{ padding:'3px 8px', border:'1px solid #dee2e6', textAlign:'center', whiteSpace:'nowrap' }}>
                                                                    <Button icon="pi pi-pencil" size="small" severity="warning"
                                                                        className="p-button-text"
                                                                        onClick={() => handleBonusSelect(b)} />
                                                                    <Button icon="pi pi-times" size="small" severity="danger"
                                                                        className="p-button-text"
                                                                        onClick={() => handleDeleteBonus(b.id)} />
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr style={{ background:'#f8f9fa', fontWeight:600 }}>
                                                        <td style={{ padding:'4px 8px', border:'1px solid #dee2e6' }}>UKUPNO</td>
                                                        <td style={{ padding:'4px 8px', border:'1px solid #dee2e6', textAlign:'right' }}>{fmt(totalBonusDod)}</td>
                                                        {!isLocked && <td style={{ border:'1px solid #dee2e6' }}></td>}
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        ) : (
                                            <p style={{ fontSize:12, color:'#6c757d', margin:0 }}>Nema dodatnih bonusa.</p>
                                        )}
                                    </div>
                                )}

                                {/* DANI */}
                                {unosTab === 4 && (
                                    <div style={{ marginTop:16, borderTop:'1px solid #dee2e6', paddingTop:12 }}>
                                        <div style={{ fontWeight:600, marginBottom:8, fontSize:16 }}>
                                            Dani rada — ukupno: <strong>{fmt(totalDaniKoef)}</strong> dana
                                            <span style={{ color:'#6c757d', fontWeight:400, fontSize:14, marginLeft:8 }}>(G/B = godišnji/bolovanje, R = fix-tura van dnevnica)</span>
                                            {!isLocked && <span style={{ color:'#6c757d', fontWeight:400, fontSize:14, marginLeft:8 }}>| Klik = promeni (0 → 0.5 → 1.0 → 0)</span>}
                                        </div>
                                        <div style={{ display:'grid', gridTemplateColumns:'repeat(7, 1fr)', gap:5, maxWidth:560 }}>
                                            {['Pon','Uto','Sre','Čet','Pet','Sub','Ned'].map((lbl, i) => (
                                                <div key={lbl} style={{
                                                    fontSize:10, fontWeight:700, textAlign:'center',
                                                    color: i >= 5 ? '#dc3545' : '#6c757d',
                                                }}>{lbl}</div>
                                            ))}
                                            {daniWeeks.map((week, wi) => (
                                                week.map((d, ci) => {
                                                    if (!d) return <div key={`${wi}-${ci}`} />;
                                                    const isWknd = ci >= 5;
                                                    const isEmpty = !!d._empty;
                                                    return (
                                                        <button key={d.id || d.datum} type="button"
                                                            onClick={() => handleToggleDan(d)}
                                                            disabled={isLocked}
                                                            style={{
                                                                border: `1px solid ${isWknd ? '#adb5bd' : (isEmpty ? '#e0e0e0' : '#ced4da')}`,
                                                                borderRadius:4, padding:'3px 6px',
                                                                cursor: isLocked ? 'default' : 'pointer',
                                                                background: isEmpty
                                                                    ? (isWknd ? '#f1f3f5' : '#fafafa')
                                                                    : (isWknd && d.koeficijent === 0 ? '#e9ecef' : koefBg(d.koeficijent)),
                                                                color: isEmpty ? '#c0c0c0' : koefColor(d.koeficijent),
                                                                fontWeight:600, fontSize:11, textAlign:'center',
                                                                opacity: isEmpty ? 0.75 : 1,
                                                            }}>
                                                            <div style={{ fontSize:10, color: isEmpty ? '#c0c0c0' : (isWknd ? '#868e96' : 'inherit') }}>
                                                                {d.datumPrikaz?.slice(0,5)}
                                                            </div>
                                                            <div>
                                                                {isEmpty ? '+' : d.koeficijent === 0 ? '—' : (d.tip_dan === 'G' || d.tip_dan === 'B' || d.tip_dan === 'R') ? `${Number(d.koeficijent).toFixed(1)} ${d.tip_dan}` : d.koeficijent}
                                                            </div>
                                                        </button>
                                                    );
                                                })
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </Card>
                        )}

                        {/* Nalozi tabela */}
                        {obracunId && (
                            <Card style={{ minWidth:0 }}>
                                {showAddTrip && !isLocked && (
                                    <div style={{ marginBottom:10, padding:'8px 12px', background:'#e8f4fd', borderRadius:6, border:'1px solid #bee3f8', display:'flex', gap:10, alignItems:'flex-end' }}>
                                        <div>
                                            <label style={{ display:'block', marginBottom:2 }}>{t('finansije.izaberiTuruDodavanje')}</label>
                                            <Dropdown
                                                value={selectedAddTrip}
                                                options={(availableTrips || []).map(t => ({ value: t.id_putni_nalog, label: `${t.br_naloga} (${t.dat_od} — ${t.dat_do})` }))}
                                                onChange={e => setSelectedAddTrip(e.value)}
                                                placeholder={loadingAvailable ? 'Učitavanje...' : 'Izaberi turu...'}
                                                style={{ width:360 }} filter
                                                emptyMessage="Nema dostupnih tura" />
                                        </div>
                                        <Button label={t('common.add')} icon="pi pi-check" size="small" severity="success"
                                            loading={addingTrip} disabled={!selectedAddTrip || loadingAvailable}
                                            onClick={handleAddNalogManual} />
                                    </div>
                                )}
                                <div style={{ overflowX:'auto' }}>
                                <DataTable className="stavke-tabela" value={nalozi} size="small" scrollable scrollHeight="240px"
                                    globalFilter={naloziGlobalFilter}
                                    header={naloziHeader}
                                    rowClassName={r => r.id === selectedNalogId ? { 'p-highlight': true } : {}}>
                                    <Column header={t('nova.izaberi')} style={{ minWidth:90 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }}
                                        body={r => (
                                            <Button label={t('nova.izaberi')} icon="pi pi-eye" type="button"
                                                className="p-button-text p-button-sm"
                                                disabled={isLocked}
                                                onClick={() => handleNalogSelect(r)} />
                                        )} />
                                    <Column field="br_naloga"       header={t('finansije.nalog')}    footer="UKUPNO" style={{ minWidth:90 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} footerStyle={{ textAlign:'center' }}
                                        body={r => <span>{r.br_naloga}{r.ima_rusiju ? <span style={{ marginLeft:4, fontSize:10, fontWeight:700, color:'#721c24' }}>RUS FIX</span> : ''}</span>} />
                                    <Column field="dat_od"          header={t('finansije.od')}       style={{ minWidth:90 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} />
                                    <Column field="dat_do"          header={t('finansije.do')}       style={{ minWidth:90 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} />
                                    <Column field="km"              header={t('finansije.km')}       style={{ minWidth:70 }}  bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} body={r => <span>{r.km != null ? fmt(r.km) : ''}</span>} />
                                    <Column field="dodatni_km"      header={t('finansije.dodKM')}  style={{ minWidth:80 }}  bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} body={r => <span>{r.dodatni_km ? fmt(r.dodatni_km) : ''}</span>} />
                                    <Column field="iznos_eur"       header={t('ture.iznosEur')}  style={{ minWidth:80 }}  bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} footerStyle={{ textAlign:'center' }} body={r => <span>{r.iznos_eur != null ? fmt(r.iznos_eur) : ''}</span>}
                                        footer={<span>{fmt(totalNaloziIznos)}</span>} />
                                    <Column field="akontacija_eur"  header={t('finansije.akonEur')}  style={{ minWidth:80 }}  bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} body={r => <span>{r.akontacija_eur != null ? fmt(r.akontacija_eur) : ''}</span>} />
                                    <Column header={t('finansije.trosakEur')} style={{ minWidth:80 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} footerStyle={{ textAlign:'center' }} body={r => <span>{r.trosak_gotovina_eur != null ? fmt(r.trosak_gotovina_eur) : ''}</span>}
                                        footer={<span>{fmt(totalNaloziTrosak)}</span>} />
                                </DataTable>
                                </div>

                                {selectedNalogId && !isLocked && (
                                    <div style={{ marginTop:12, padding:'10px 12px', background:'#f0f4ff', borderRadius:6, border:'1px solid #c8d6f5' }}>
                                        <div style={{ display:'flex', flexWrap:'wrap', gap:8, alignItems:'flex-end' }}>
                                            {[
                                                ['KM','km',2],['Dodatni KM','dodatni_km',2],['Iznos €','iznos_eur',2],
                                            ].map(([lbl, key, dec]) => (
                                                <div key={key}>
                                                    <label style={{ display:'block', marginBottom:2 }}>{lbl}</label>
                                                    <InputNumber value={formNalog[key]}
                                                        disabled={key === 'iznos_eur'}
                                                        onValueChange={e => setFormNalog(p => ({ ...p, [key]: e.value }))}
                                                        mode="decimal" minFractionDigits={dec} maxFractionDigits={dec}
                                                        inputStyle={{ width:90, textAlign:'right' }} />
                                                </div>
                                            ))}
                                            <div>
                                                <label style={{ display:'block', marginBottom:2 }}>{t('nova.napomena')}</label>
                                                <InputText value={formNalog.napomena}
                                                    onChange={e => setFormNalog(p => ({ ...p, napomena: e.target.value }))}
                                                    style={{ width:260 }} />
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </Card>
                        )}

                    </div>
                </div>
            )}

            {/* ====================== PREGLED ====================== */}
            {changeView === 2 && (
                <div className="col-12">
                    <div className="blagajnaDashboard dnevniceDashboard">

                        {/* Filteri */}
                        <Card>
                            <div style={{ display:'flex', flexWrap:'wrap', gap:10, alignItems:'flex-end' }}>
                                <div>
                                    <label style={{ display:'block', marginBottom:3 }}>{t('finansije.zaposleni')}</label>
                                    <Dropdown value={filterZap} options={zaposleniDB}
                                        onChange={e => setFilterZap(e.value)}
                                        placeholder={t('finansije.svi')} showClear style={{ width:200 }} />
                                </div>
                                <div>
                                    <label style={{ display:'block', marginBottom:3 }}>{t('finansije.mesec')}</label>
                                    <Dropdown value={filterMesec} options={MESECI}
                                        onChange={e => setFilterMesec(e.value)}
                                        placeholder={t('finansije.svi')} showClear style={{ width:140 }} />
                                </div>
                                <div>
                                    <label style={{ display:'block', marginBottom:3 }}>{t('finansije.godina')}</label>
                                    <InputNumber value={filterGodina} onValueChange={e => setFilterGodina(e.value)}
                                        mode="decimal" useGrouping={false} style={{ width:90 }} />
                                </div>
                                <Button label={t('finansije.pretrazi')} icon="pi pi-search" severity="primary" onClick={loadPregled} />
                            </div>
                        </Card>

                        {/* DataTable */}
                        <Card>
                            <Tooltip target=".export-buttons>button" position="bottom" />
                            <DataTable className="stavke-tabela" value={pregledData} header={pregledHeader}
                                globalFilter={pregledGlobalFilter}
                                paginator rows={10}
                                scrollable scrollHeight="50vh"
                                emptyMessage="Nema podataka. Kliknite Pretraži."
                                rowClassName={r => String(r.id) === String(selectedPregledId) ? { 'selected-row': true } : {}}>
                                <Column header={t('nova.izaberi')} style={{ minWidth:90 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }}
                                    body={r => (
                                        <Button label={t('nova.izaberi')} icon="pi pi-eye" type="button"
                                            className="p-button-text p-button-sm"
                                            onClick={() => handlePregledSelect(r)} />
                                    )} />
                                <Column field="ZaposleniNaziv" header={t('ture.vozac')}      sortable style={{ minWidth:160 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} />
                                <Column field="dat_od"         header={t('finansije.datOd')}    sortable style={{ minWidth:100 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} />
                                <Column field="dat_do"         header={t('finansije.datDo')}    sortable style={{ minWidth:100 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} />
                                <Column field="StatusNaziv"    header={t('nova.status')}     sortable style={{ minWidth:100 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }}
                                    body={r => (
                                        <span style={{
                                            padding:'2px 8px', borderRadius:4, fontSize:12,
                                            background: r.StatusNaziv === 'ZATVOREN' ? '#343a40' : '#d4edda',
                                            color: r.StatusNaziv === 'ZATVOREN' ? '#fff' : '#155724',
                                        }}>{r.StatusNaziv}</span>
                                    )} />
                                <Column field="kurs"            header={t('nova.kurs')}       sortable style={{ minWidth:70 }}  bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} body={r => <span>{fmt(r.kurs)}</span>} />
                                <Column field="dnevnica_ukupno" header={t('finansije.dnevniceEur')} sortable style={{ minWidth:140 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} body={r => <span>{fmt(r.dnevnica_ukupno)}{r.dnevnica_rus_fix ? ` (sadrži RUS turu${r.dnevnica_rus_dani ? `, ${r.dnevnica_rus_dani} dana` : ''})` : ''}</span>} />
                                <Column field="napomena"        header={t('nova.napomena')}           style={{ minWidth:160 }} bodyStyle={{ textAlign:'center' }} headerStyle={{ textAlign:'center' }} />
                            </DataTable>
                        </Card>
                    </div>
                </div>
            )}

            {/* ====================== IZVEŠTAJI ====================== */}
            {changeView === 3 && (
                <div className="col-12">
                    <div className="blagajnaDashboard dnevniceDashboard">
                        <Card>
                            <p style={{ color:'#6c757d', margin:0 }}>Izveštaji — biće implementirani u sledećoj fazi.</p>
                        </Card>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ObracunPlate;
